'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mobxReact = require('mobx-react');
var mobx = require('mobx');
var axios = require('axios');
var webchatSdk = require('@42maru/webchat-sdk');
var moment$1 = require('moment');
var uuid = require('uuid');
var reactDeviceDetect = require('react-device-detect');
require('./assets/evPXLwtp.scss');
var Scrollbar = require('react-scrollbars-custom');
var reactVirtualized = require('react-virtualized');
var Measure = require('react-measure');
var classnames = require('classnames');
var parse = require('html-react-parser');
var reactIntl = require('react-intl');
require('./assets/ewKEZuAS.css');
require('./assets/fHnuEYQb.scss');
var ReactPlayer = require('react-player');
var reactBootstrap = require('react-bootstrap');
var ArrowNextImage = require('./assets/QdEqyusW.png');
var ArrowPrevImage = require('./assets/eGmiBQAO.png');
var broken = require('./assets/bteCiVnK.png');
var ReactDOM = require('react-dom');
var PlayIcon = require('./assets/cjSeoeNb.png');
var PauseIcon = require('./assets/dDAzACjo.png');
var VolumeIcon = require('./assets/oNheAlob.png');
var VolumeMuteIcon = require('./assets/fTcKXfrk.png');
var FullScreenIcon = require('./assets/deaRCkiQ.png');
var ReactSlider = require('react-slider');
var styled = require('styled-components');
var screenfull = require('screenfull');
require('./assets/eSbUOsIm.scss');
var ReactStars = require('react-stars');
var lodash = require('lodash');
var reactSpinners = require('react-spinners');
var cssVars = require('css-vars-ponyfill');
var Lightbox = require('react-image-lightbox');
var ClearIcon = require('./assets/cnpArDcC.png');
var Modal = require('react-modal');
var VisibilitySensor = require('react-visibility-sensor');
var FooterLogo = require('./assets/bgzjwntp.svg');
var FooterLogoHover = require('./assets/chxadWxU.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment$1);
var Scrollbar__default = /*#__PURE__*/_interopDefaultLegacy(Scrollbar);
var Measure__default = /*#__PURE__*/_interopDefaultLegacy(Measure);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);
var parse__default = /*#__PURE__*/_interopDefaultLegacy(parse);
var ReactPlayer__default = /*#__PURE__*/_interopDefaultLegacy(ReactPlayer);
var ArrowNextImage__default = /*#__PURE__*/_interopDefaultLegacy(ArrowNextImage);
var ArrowPrevImage__default = /*#__PURE__*/_interopDefaultLegacy(ArrowPrevImage);
var broken__default = /*#__PURE__*/_interopDefaultLegacy(broken);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var PlayIcon__default = /*#__PURE__*/_interopDefaultLegacy(PlayIcon);
var PauseIcon__default = /*#__PURE__*/_interopDefaultLegacy(PauseIcon);
var VolumeIcon__default = /*#__PURE__*/_interopDefaultLegacy(VolumeIcon);
var VolumeMuteIcon__default = /*#__PURE__*/_interopDefaultLegacy(VolumeMuteIcon);
var FullScreenIcon__default = /*#__PURE__*/_interopDefaultLegacy(FullScreenIcon);
var ReactSlider__default = /*#__PURE__*/_interopDefaultLegacy(ReactSlider);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var screenfull__default = /*#__PURE__*/_interopDefaultLegacy(screenfull);
var ReactStars__default = /*#__PURE__*/_interopDefaultLegacy(ReactStars);
var cssVars__default = /*#__PURE__*/_interopDefaultLegacy(cssVars);
var Lightbox__default = /*#__PURE__*/_interopDefaultLegacy(Lightbox);
var ClearIcon__default = /*#__PURE__*/_interopDefaultLegacy(ClearIcon);
var Modal__default = /*#__PURE__*/_interopDefaultLegacy(Modal);
var VisibilitySensor__default = /*#__PURE__*/_interopDefaultLegacy(VisibilitySensor);
var FooterLogo__default = /*#__PURE__*/_interopDefaultLegacy(FooterLogo);
var FooterLogoHover__default = /*#__PURE__*/_interopDefaultLegacy(FooterLogoHover);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var DEFAULT_BOTTOM_MENU_SETTINGS = {
    enable: false,
    count: 3,
    data: undefined,
    open: false,
    dim: true
};
var DEFAULT_EMBEDD_SETTINGS = {
    buttonWidth: 60,
    buttonHeight: 60,
    buttonBottom: 40,
    buttonRight: 40,
    buttonRadius: "50%",
    buttonIconWidth: 30,
    buttonIconHeight: 30,
    windowWidth: "450px",
    windowHeight: "680px",
    buttonBackgroundColor: "#000975",
    buttonIconColor: "white",
    buttonIcon: "default",
    closeIcon: "default",
    webchatHost: "",
    bannerBackgroundColorStart: "#5762CC",
    bannerBackgroundColorEnd: "#000975",
    bannerTextColor: "white",
    enableDimBackground: true,
    bannerText: "",
    zIndex: 99999999,
    show: false
};
var DEFAULT_WEBCHAT_COLORS = {
    chatBackgroundColor: "white",
    chatCloseButtonColor: "white",
    chatInputBackgroundColor: "white",
    chatInputTextColor: "#353535",
    chatInputSendButtonColor: "#000975",
    chatInputPlaceHolderColor: "#aaaaaa",
    bubbleTextColor: "#353535",
    bubbleBackgroundColor: "#eeeeee",
    bubbleBorderColor: "#eeeeee",
    bubbleOddTextColor: "#ffffff",
    bubbleOddBackgroundColor: "#1b1b1b",
    bubbleOddBorderColor: "#1b1b1b",
    bubbleButtonTextColor: "#000975",
    bubbleButtonBackgroundColor: "#eeeeee",
    bubbleButtonBorderColor: "#c4c4c4",
    bubbleButtonHoverColor: "#c9cdff",
    bubbleTimeColor: "#aaaaaa",
    carouselTextColor: "#353535",
    carouselBackgroundColor: "white",
    carouselBorderColor: "#c4c4c4",
    carouselButtonBackgroundColor: "#ffffff",
    carouselButtonBorderColor: "#000975",
    carouselButtonTextColor: "#000975",
    carouselButtonHoverColor: "#c9cdff",
    carouselArrowColor: "#333333",
    chatTitleBackgroundColor: "#000975",
    chatTitleTextColor: "#ffffff",
    suggestionButtonTextColor: "#000975",
    suggestionButtonBorderColor: "#000975",
    suggestionButtonBackgroundColor: "#ffffff",
    suggestionButtonHoverColor: "#ffffff",
    feedbackBackgroundColor: "white",
    feedbackTextColor: "#707070",
    feedbackGoodButtonColor: "#707070",
    feedbackGoodButtonHoverColor: "#000975",
    feedbackBadButtonColor: "#707070",
    feedbackBadButtonHoverColor: "#000975",
    carouselButtonPreparingBackgroundColor: "gray",
    carouselButtonPreparingTextColor: "white",
    suggestionButtonPreparingTextColor: "white",
    suggestionButtonPreparingBackgroundColor: "gray",
    carouselButtonPreparingBorderColor: "gray",
    suggestionButtonPreparingBorderColor: "gray",
    avatarNameTextColor: "#000975",
    showMoreColor: "#000975",
    autocompleteHighlightColor: "#000975",
    popupButtonTextColor: "#ffffff",
    popupButtonBackgroundColor: "#000975",
    popupButtonBorderColor: "#000975",
    bottomMenuButtonColor: "#000975",
    bottomMenuTextColor: "#000000",
    bottomMenuBackgroundColor: "#ffffff",
    bottomMenuBorderColor: "#e9e9e9"
};
var DEFAULT_WEBCHAT_THEME = {
    title: "WebChat",
    description: "",
    titleImageUrl: "",
    faviconUrl: "",
    showAvatar: false,
    avatarUrl: "https://cdn.42maru.com/static/images/42maru/logo-blue-sm.png",
    avatarName: "",
    avatarSize: "34px",
    roundAvatar: true,
    avatarPosition: "top",
    chatInputPlaceholder: "Enter your text",
    showCloseButton: true,
    showLogoutButton: false,
    colors: DEFAULT_WEBCHAT_COLORS,
    useAutoComplete: false,
    autoCompleteLimit: 5,
    useFeedbackCollector: false,
    feedbackText: "챗봇의 답변이 도움이 되셨나요?",
    mediaWithoutBubble: false,
    buttonTextAlign: "left",
    carouselButtonTextAlign: "left",
    carouselButtonBorderRadius: "2px 2px 2px 2px",
    hideCustomUIMessage: false,
    useReadMore: false,
    readMoreLine: 10,
    embeddedSettings: DEFAULT_EMBEDD_SETTINGS,
    messageDelay: 0,
    bottomMenu: DEFAULT_BOTTOM_MENU_SETTINGS,
    preventWelcomeScroll: false,
    showFooter: false
};
var STYLE_PROPERTY_KEYS = {
    chatBackgroundColor: "--chat-background-color",
    chatCloseButtonColor: "--chat-close-button-color",
    chatInputBackgroundColor: "--chat-input-background-color",
    chatInputTextColor: "--chat-input-text-color",
    chatInputSendButtonColor: "--chat-input-send-button-color",
    chatInputPlaceHolderColor: "--chat-input-placeholder-color",
    bubbleTextColor: "--bubble-text-color",
    bubbleBackgroundColor: "--bubble-background-color",
    bubbleBorderColor: "--bubble-border-color",
    bubbleOddTextColor: "--bubble-odd-text-color",
    bubbleOddBackgroundColor: "--bubble-odd-background-color",
    bubbleOddBorderColor: "--bubble-odd-border-color",
    bubbleButtonTextColor: "--bubble-button-text-color",
    bubbleButtonBackgroundColor: "--bubble-button-background-color",
    bubbleButtonBorderColor: "--bubble-button-border-color",
    bubbleButtonHoverColor: "--bubble-button-hover-color",
    bubbleTimeColor: "--bubble-time-color",
    carouselTextColor: "--carousel-text-color",
    carouselBackgroundColor: "--carousel-background-color",
    carouselBorderColor: "--carousel-border-color",
    carouselButtonBackgroundColor: "--carousel-button-background-color",
    carouselButtonBorderColor: "--carousel-button-border-color",
    carouselButtonTextColor: "--carousel-button-text-color",
    carouselButtonHoverColor: "--carousel-button-hover-color",
    carouselButtonPreparingBackgroundColor: "--carousel-button-preparing-background-color",
    carouselButtonPreparingTextColor: "--carousel-button-preparing-text-color",
    carouselButtonPreparingBorderColor: "--carousel-button-preparing-border-color",
    carouselArrowColor: "--carousel-arrow-color",
    chatTitleTextColor: "--chat-title-text-color",
    chatTitleBackgroundColor: "--chat-title-background-color",
    chatTitleBackgroundColorStart: "--chat-title-background-color-start",
    chatTitleBackgroundColorEnd: "--chat-title-background-color-end",
    suggestionButtonPreparingTextColor: "--suggestion-button-preparing-text-color",
    suggestionButtonPreparingBackgroundColor: "--suggestion-button-preparing-background-color",
    suggestionButtonTextColor: "--suggestion-button-text-color",
    suggestionButtonBorderColor: "--suggestion-button-border-color",
    suggestionButtonPreparingBorderColor: "--suggestion-button-preparing-border-color",
    suggestionButtonBackgroundColor: "--suggestion-button-background-color",
    suggestionButtonHoverColor: "--suggestion-button-hover-color",
    feedbackBackgroundColor: "--chat-feedback-background-color",
    feedbackTextColor: "--chat-feedback-text-color",
    feedbackGoodButtonColor: "--chat-feedback-good-button-color",
    feedbackGoodButtonHoverColor: "--chat-feedback-good-button-hover-color",
    feedbackBadButtonColor: "--chat-feedback-bad-button-color",
    feedbackBadButtonHoverColor: "--chat-feedback-bad-button-hover-color",
    avatarNameTextColor: "--avatar-name-text-color",
    showMoreColor: "--show-more-color",
    autocompleteHighlightColor: "--autocomplete-highlight-color",
    popupButtonTextColor: "--popup-button-text-color",
    popupButtonBackgroundColor: "--popup-button-background-color",
    popupButtonBorderColor: "--popup-button-border-color",
    bottomMenuButtonColor: "--bottom-menu-button-color",
    bottomMenuTextColor: "--bottom-menu-text-color",
    bottomMenuBackgroundColor: "--bottom-menu-background-color",
    bottomMenuBorderColor: "--bottom-menu-border-color",
};

var suggestions = function (host, scenarioId, query, channel) {
    return axios__default['default']
        .get(host + "/message/suggestions", {
        params: {
            scenario_id: scenarioId,
            query: query,
            channel: channel
        }
    })
        .then(function (response) { return Promise.resolve(response.data); })
        .catch(function (error) { return Promise.reject(error); });
};
var sendFeedback = function (host, feedback) {
    return axios__default['default']
        .post(host + "/message/feedback", feedback)
        .then(function (response) { return Promise.resolve(response.data); })
        .catch(function (error) { return Promise.reject(error); });
};
var submitCustomData = function (host, data) {
    return axios__default['default']
        .post("" + host, data)
        .then(function (response) { return Promise.resolve(response.data); })
        .catch(function (error) { return Promise.reject(error); });
};

var ChatStore = /** @class */ (function () {
    function ChatStore() {
        var _this = this;
        this.data = [];
        this.suggestions = [];
        this.conversationId = "";
        this.messagingUserId = "";
        this.scenarioId = "";
        this.detectDuplicateConnection = false;
        this.connected = false;
        this.socketInitialized = false;
        this.timerMap = new Map();
        this.welcomeRequested = false;
        this.setConnectionConfig = function (config) {
            _this.connectionConfig = config;
        };
        this.requestWelcome = function () {
            _this.welcomeRequested = true;
            if (_this.socket && _this.data.length === 0) {
                _this.socket.emit("welcome", {
                    scenario_id: _this.scenarioId,
                    messaging_user_id: _this.messagingUserId,
                    conversation_id: _this.conversationId
                });
            }
        };
        this.connectSocket = function (userKey, scenarioId, channel, conversationId, opts, params) {
            if (conversationId === void 0) { conversationId = ""; }
            if (opts === void 0) { opts = {}; }
            if (params === void 0) { params = {}; }
            _this.channel = channel;
            _this.scenarioId = scenarioId;
            if (!_this.socket) {
                _this.socket = new webchatSdk.ChatSocket(_this.connectionConfig.socketHost, opts);
                var connectParams = __assign(__assign({}, params), { user_key: userKey, channel: channel, scenario_id: scenarioId });
                if (conversationId && conversationId.length > 0) {
                    connectParams["conversation_id"] = conversationId;
                }
                _this.socket.connect(connectParams);
                _this.socket.on("connected", function (response) {
                    if (_this.conversationId !== response.data["conversation_id"]) {
                        _this.messagingUserId = response.data["messaging_user_id"];
                        _this.conversationId = response.data["conversation_id"];
                        _this.sid = response.data["sid"];
                        if (_this.welcomeRequested) {
                            _this.requestWelcome();
                        }
                    }
                    else if (_this.conversationId && _this.conversationId === response.data["conversation_id"]) {
                        if (_this.connected) {
                            _this.detectDuplicateConnection = true;
                            _this.disconnect();
                        }
                    }
                    _this.connected = true;
                });
                _this.socket.on("disconnect", function (response) {
                    _this.connected = false;
                });
                _this.socket.on("response", function (response) {
                    _this.data = __spreadArrays(_this.data, [response.data]);
                    _this.messagingUserId = response.data["messaging_user_id"];
                    _this.conversationId = response.data["conversation_id"];
                });
                _this.socket.on("chat_ack", function (response) {
                    var timer = _this.timerMap.get(response.id);
                    if (timer) {
                        clearTimeout(timer);
                        _this.timerMap.delete(response.id);
                    }
                    _this.updateMessageStatus(response.id, "success");
                });
                _this.socketInitialized = true;
            }
        };
        this.disconnect = function () {
            try {
                _this.socket.disconnect();
            }
            catch (e) { }
            _this.connected = false;
        };
        this.sendMessage = function (data) {
            if (_this.connectionConfig) {
                if (_this.connectionConfig.method === "socket") {
                    if (_this.connected) {
                        _this.timerMap.set(data.id, setTimeout(function () {
                            _this.updateMessageStatus(data.id, "failed");
                        }, 5000));
                        _this.emit("chat", data);
                    }
                    else {
                        _this.updateMessageStatus(data.id, "failed");
                    }
                }
                else {
                    _this.sendRest(data).catch(function (e) {
                        throw e;
                    });
                }
            }
        };
        this.updateMessageStatus = function (id, status) {
            var find = _this.data.find(function (message) { return message.id === id; });
            if (find) {
                find.status = status;
            }
        };
        this.deleteMessage = function (id) {
            _this.data = _this.data.filter(function (message) { return message.id !== id; });
        };
        this.addData = function (data) {
            var find = _this.data.find(function (message) { return message.id === data.id; });
            if (!find) {
                _this.data = __spreadArrays(_this.data, [data]);
            }
        };
        this.emit = function (event, data) {
            if (_this.socketInitialized && _this.socket) {
                _this.socket.emit(event, data);
            }
            else {
                throw "Socket is not initialized";
            }
        };
        this.welcomeRest = function (userKey, scenarioId, channel) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.connectionConfig) return [3 /*break*/, 2];
                        return [4 /*yield*/, webchatSdk.welcome(this.connectionConfig.apiHost, userKey, scenarioId, channel)];
                    case 1:
                        response = _a.sent();
                        this.scenarioId = scenarioId;
                        this.data = __spreadArrays(this.data, [response.data]);
                        this.conversationId = response.data["conversation_id"];
                        this.messagingUserId = response.data["messaging_user_id"];
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.sendRest = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.connectionConfig) return [3 /*break*/, 2];
                        return [4 /*yield*/, webchatSdk.send(this.connectionConfig.apiHost, data)];
                    case 1:
                        response = _a.sent();
                        this.data = __spreadArrays(this.data, [response.data]);
                        this.conversationId = response.data["conversation_id"];
                        this.messagingUserId = response.data["messaging_user_id"];
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.clear = function () {
            _this.data = [];
            _this.conversationId = "";
            _this.messagingUserId = "";
            _this.scenarioId = "";
            _this.disconnect();
            _this.detectDuplicateConnection = false;
            _this.socket = undefined;
            _this.socketInitialized = false;
        };
        this.sendFeedback = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.connectionConfig) return [3 /*break*/, 2];
                        return [4 /*yield*/, sendFeedback(this.connectionConfig.apiHost, data)];
                    case 1:
                        response = _a.sent();
                        this.lastFeedbackId = data.id;
                        return [2 /*return*/, Promise.resolve(response.data)];
                    case 2: return [2 /*return*/, Promise.reject()];
                    case 3:
                        e_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getSuggestions = function (scenarioId, query) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.connectionConfig) return [3 /*break*/, 2];
                        return [4 /*yield*/, suggestions(this.connectionConfig.apiHost, scenarioId, query, this.channel)];
                    case 1:
                        response = _a.sent();
                        this.suggestions = response.data;
                        return [2 /*return*/, Promise.resolve(response.data)];
                    case 2: return [2 /*return*/, Promise.reject()];
                    case 3:
                        e_4 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.clearSuggestions = function () {
            _this.suggestions = [];
        };
    }
    Object.defineProperty(ChatStore.prototype, "lastMessage", {
        get: function () {
            var lastMessageInfo = this.data[this.data.length - 1];
            return ((lastMessageInfo &&
                lastMessageInfo.messages &&
                lastMessageInfo.messages[lastMessageInfo.messages.length - 1]) ||
                {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChatStore.prototype, "lastMessageInfo", {
        get: function () {
            var lastMessageInfo = this.data[this.data.length - 1];
            return lastMessageInfo;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "data", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "suggestions", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "conversationId", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "messagingUserId", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "scenarioId", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "lastFeedbackId", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "detectDuplicateConnection", void 0);
    __decorate([
        mobx.observable
    ], ChatStore.prototype, "connected", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "connectSocket", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "updateMessageStatus", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "deleteMessage", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "addData", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "welcomeRest", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "sendRest", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "clear", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "sendFeedback", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "getSuggestions", void 0);
    __decorate([
        mobx.action
    ], ChatStore.prototype, "clearSuggestions", void 0);
    __decorate([
        mobx.computed
    ], ChatStore.prototype, "lastMessage", null);
    __decorate([
        mobx.computed
    ], ChatStore.prototype, "lastMessageInfo", null);
    return ChatStore;
}());
var store = new ChatStore();

var makeUserMessages = function (text, payload) {
    var textMessage = text;
    if (payload && payload.startsWith("text:")) {
        textMessage = payload.replace("text:", "");
    }
    if (!textMessage || textMessage.replace(/ /, "").length == 0) {
        textMessage = text;
    }
    return [
        {
            type: "output",
            data_type: "text",
            data: [
                {
                    text: textMessage,
                    payload: payload
                }
            ]
        }
    ];
};
var makeUserData = function (scenarioId, conversationId, messagingUserId, messages, sourceId, isPrint) {
    if (isPrint === void 0) { isPrint = true; }
    var currentUtcTime = moment__default['default'].utc().format("YYYY-MM-DD HH:mm:ss.SSSSS");
    var data = {
        id: uuid.v4(),
        scenario_id: scenarioId,
        conversation_id: conversationId,
        messaging_user_id: messagingUserId,
        source_id: sourceId,
        sender: {
            type: "user"
        },
        messages: messages,
        created_at: currentUtcTime,
        updated_at: currentUtcTime,
        status: "sending"
    };
    if (isPrint) {
        store.addData(data);
    }
    return data;
};
var openLink = function (link_mobile, link_pc) {
    if (reactDeviceDetect.isMobile) {
        window.open(link_mobile, "_blank");
    }
    else {
        window.open(link_pc || link_mobile, "_blank");
    }
};
var isUrl = function (url) {
    var expression = /([a-zA-Z]{2,20}):\/\/([\w_-]+(?:(?:\.[\w_-]+)?))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/gi;
    var regex = new RegExp(expression);
    return regex.test(url);
};

var DELIMITER = '\u0001';
// eslint-disable-next-line no-useless-escape
var REGEX_URL = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

var splitByURL = function (text) {
    return text.replace(REGEX_URL, function (text) { return DELIMITER + text + DELIMITER; }).split(DELIMITER);
};
var splitByText = function (text, splitText) {
    var regex = new RegExp("" + splitText, 'i');
    return text.replace(regex, function (text) { return DELIMITER + text + DELIMITER; }).split(DELIMITER);
};

var DefaultUrl = function (_a) {
    var url = _a.url, props = __rest(_a, ["url"]);
    return (React__default['default'].createElement("a", __assign({ href: url }, props, { rel: "noopener noreferrer", target: "_blank" }), url));
};

var linkify = function (text, Component) {
    if (Component === void 0) { Component = DefaultUrl; }
    var dataArray = splitByURL(text);
    var result = dataArray.map(function (el, index) {
        var isUrl = REGEX_URL.test(el);
        // if (!isUrl) {
        //     const textArray = splitByDoubleQuotes(el);
        //     return textArray.map((el, index) => {
        //         const hasDoubleQuotes = REGEX_BOLD.test(el);
        //         if (hasDoubleQuotes) {
        //             return <b key={`bold_text${index}`}>{el}</b>;
        //         } else {
        //             return <Fragment key={`text${index}`}>{el}</Fragment>;
        //         }
        //     });
        // }
        if (isUrl) {
            return React__default['default'].createElement(Component, { key: "url" + index, url: el });
        }
        else {
            return React__default['default'].createElement(React.Fragment, { key: "text" + index }, el);
        }
    });
    return result;
};
var Linkify = function (_a) {
    var children = _a.children;
    var text = "" + children || "";
    var hasHtml = /<\/?[a-z][\s\S]*>/i.test(text);
    if (hasHtml) {
        return React__default['default'].createElement("div", null, parse__default['default'](text));
    }
    return React__default['default'].createElement("div", null, linkify(text));
};

var WebChatDialogStore = /** @class */ (function () {
    function WebChatDialogStore() {
        var _this = this;
        this.show = false;
        this.message = "";
        this.open = function (params) {
            _this.show = true;
            _this.title = params.title;
            _this.message = params.message;
            _this.confirmText = params.confirmText;
            _this.onConfirm = params.onConfirm;
            _this.textAlign = params.textAlign;
        };
        this.confirm = function () {
            _this.onConfirm && _this.onConfirm();
            _this.clear();
        };
        this.clear = function () {
            _this.show = false;
            _this.onConfirm = undefined;
        };
    }
    __decorate([
        mobx.observable
    ], WebChatDialogStore.prototype, "show", void 0);
    __decorate([
        mobx.action
    ], WebChatDialogStore.prototype, "open", void 0);
    __decorate([
        mobx.action
    ], WebChatDialogStore.prototype, "confirm", void 0);
    __decorate([
        mobx.action
    ], WebChatDialogStore.prototype, "clear", void 0);
    return WebChatDialogStore;
}());
var webChatDialogStore = new WebChatDialogStore();

var heightMap = new Map();
var truncateStringByLine = function (line, text, options) {
    var clientHeight = heightMap.get(text);
    var textPartsByLineBreak = text.split("\n").slice(0, line);
    var slicedText = textPartsByLineBreak.join("\n");
    if (!clientHeight) {
        var div = document.createElement("div");
        div.style.cssText =
            "white-space: pre-wrap; word-break: break-word; width: auto; max-width: 250px; font-family: Noto Sans KR, Arial, sans-serif; font-size: 0.938em; line-height: 22px; text-overflow: ellipsis; overflow: hidden;";
        div.innerHTML = slicedText;
        document.body.appendChild(div);
        clientHeight = div.clientHeight;
        heightMap.set(text, clientHeight);
        try {
            document.body.removeChild(div);
        }
        catch (e) { }
    }
    var lineHeight = (options && options.lineHeight) || 22;
    if (clientHeight <= lineHeight * line) {
        if (slicedText !== text) {
            return slicedText + "...";
        }
        return slicedText;
    }
    var textLines = textPartsByLineBreak.length;
    var LENGTH_BY_LINE_K = 15;
    var expectedTextLength = LENGTH_BY_LINE_K * 1.5 * line - (textLines - 1) * LENGTH_BY_LINE_K;
    var matches = text.match(/<\/[a-zA-Z]+>|\/>/g);
    if (matches) {
        var previousIndex = 0;
        for (var i = 0; i < matches.length; i++) {
            var token = matches[i];
            var findIndex = text.indexOf(token, previousIndex);
            previousIndex = findIndex;
            if (findIndex + token.length > expectedTextLength) {
                expectedTextLength = findIndex + token.length;
                break;
            }
        }
    }
    if (expectedTextLength < slicedText.length) {
        var truncatedText = slicedText.substring(0, Math.round(expectedTextLength));
        return truncatedText + "...";
    }
    return slicedText;
};
var getRandomId = function (length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
var getUserKey = function () {
    try {
        var savedUserKey = localStorage.getItem("chat_user_key");
        if (savedUserKey) {
            return savedUserKey;
        }
    }
    catch (e) { }
    var randomHashValue = getRandomId(32);
    try {
        localStorage.setItem("chat_user_key", randomHashValue);
    }
    catch (e) { }
    return randomHashValue;
};

var messages$1 = {
    i0001: "알림",
    i0002: "확인",
    i0003: "전체보기",
    i0004: "동일한 대화가 시작되어 현재 대화를 종료합니다",
    i0005: "서버와 연결이 끊겼습니다.",
    i0006: "재전송",
    i0007: "삭제"
};

var messages = {
    i0001: "Notification",
    i0002: "Confirm",
    i0003: "View more",
    i0004: "Another conversation window started. Close this window.",
    i0005: "Disconnected from the server.",
    i0006: "Resend",
    i0007: "Delete"
};

var locale = {
    ko: messages$1,
    en: messages
};

var IntlStore = /** @class */ (function () {
    function IntlStore(localeString) {
        this.locale = localeString || "ko";
        this.cache = reactIntl.createIntlCache();
        this.intl = reactIntl.createIntl({
            locale: this.locale,
            messages: locale[this.locale]
        }, this.cache);
    }
    IntlStore.getInstance = function (localeString) {
        if (IntlStore._instance == null || (localeString && IntlStore._instance.locale !== localeString)) {
            IntlStore._instance = new IntlStore(localeString);
        }
        return IntlStore._instance;
    };
    return IntlStore;
}());

var TextContent = function (_a) {
    var message = _a.message, useReadMore = _a.useReadMore, readMoreLine = _a.readMoreLine, onLoad = _a.onLoad;
    var intl = IntlStore.getInstance().intl;
    var text = "";
    if (Array.isArray(message.data)) {
        text = message.data[0].text || "";
    }
    else {
        text = message.text || (message.data && message.data.text) || "";
    }
    var onClickDetails = function (e) {
        e.preventDefault();
        e.stopPropagation();
        webChatDialogStore.open({
            title: intl.formatMessage({ id: "i0003" }),
            message: text,
            confirmText: intl.formatMessage({ id: "i0002" }),
            textAlign: "left"
        });
    };
    onLoad && onLoad();
    if (text.length > 0) {
        if (useReadMore && readMoreLine) {
            var truncatedText = truncateStringByLine(readMoreLine, text);
            return (React__default['default'].createElement("div", { style: { whiteSpace: "pre-wrap", wordBreak: "break-word" } },
                React__default['default'].createElement(Linkify, null, truncatedText),
                truncatedText !== text && (React__default['default'].createElement("a", { href: "#", onClick: onClickDetails },
                    React__default['default'].createElement("div", { className: "show-more" },
                        React__default['default'].createElement("div", null, intl.formatMessage({ id: "i0003" })),
                        React__default['default'].createElement("div", { className: "show-more-arrow" }, "＞"))))));
        }
        else {
            return (React__default['default'].createElement("div", { style: { whiteSpace: "pre-wrap", wordBreak: "break-word" } },
                React__default['default'].createElement(Linkify, null, text)));
        }
    }
    return React__default['default'].createElement(React__default['default'].Fragment, null);
};

var LightBoxStore = /** @class */ (function () {
    function LightBoxStore() {
        var _this = this;
        this.show = false;
        this.open = function (src) {
            _this.src = src;
            _this.show = true;
        };
        this.clear = function () {
            _this.src = undefined;
            _this.show = false;
        };
    }
    __decorate([
        mobx.observable
    ], LightBoxStore.prototype, "show", void 0);
    __decorate([
        mobx.observable
    ], LightBoxStore.prototype, "src", void 0);
    __decorate([
        mobx.action
    ], LightBoxStore.prototype, "open", void 0);
    __decorate([
        mobx.action
    ], LightBoxStore.prototype, "clear", void 0);
    return LightBoxStore;
}());
var lightBoxStore = new LightBoxStore();

var ChatButton = function (_a) {
    var data = _a.data, disabled = _a.disabled, className = _a.className, showLinkIcon = _a.showLinkIcon, textAlign = _a.textAlign, style = _a.style, sourceMessageId = _a.sourceMessageId, onLoad = _a.onLoad;
    var intl = IntlStore.getInstance().intl;
    var isImageLink = React.useRef(false);
    var onClick = function (e) {
        e.preventDefault();
        if (data.label) {
            if (data.button_type === "link" && data.link_mobile) {
                if (isImageLink.current) {
                    lightBoxStore.open(data.link_mobile);
                }
                else if (isUrl(data.link_mobile)) {
                    openLink(data.link_mobile, data.link_pc);
                }
                else {
                    webChatDialogStore.open({
                        title: intl.formatMessage({ id: "i0001" }),
                        message: data.link_mobile,
                        confirmText: intl.formatMessage({ id: "i0002" })
                    });
                }
            }
            else {
                try {
                    var messages = makeUserMessages(data.label, data.payload);
                    var chatData = makeUserData(store.scenarioId, store.conversationId, store.messagingUserId, messages, sourceMessageId);
                    store.sendMessage(chatData);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    };
    var onImageLoad = function (e) {
        isImageLink.current = true;
    };
    var onImageError = function (e) {
        isImageLink.current = false;
    };
    var justifyContent = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flext-end" : "center";
    var isDim = data.button_type === "link" && data.link_mobile && !isUrl(data.link_mobile);
    onLoad && onLoad();
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("button", { disabled: disabled, className: classnames__default['default'](className, {
                dim: isDim
            }), onClick: onClick, style: __assign({ textAlign: textAlign }, style) },
            React__default['default'].createElement("div", { style: { display: "flex", justifyContent: justifyContent } },
                React__default['default'].createElement("div", { style: { alignSelf: "center", width: showLinkIcon ? "calc(100% - 8px)" : "100%" } }, data.label),
                showLinkIcon && data.button_type === "link" && data.link_mobile && (React__default['default'].createElement("svg", { className: classnames__default['default']("link-icon", { dim: isDim }), viewBox: "0 0 8 8" },
                    React__default['default'].createElement("g", null,
                        React__default['default'].createElement("g", null,
                            React__default['default'].createElement("path", { className: "st0", d: "M7.6,7C7.3,7,7.1,6.8,7.1,6.5V0.9H1.5C1.2,0.9,1,0.7,1,0.4S1.2,0,1.5,0h6.1C7.8,0,8,0.2,8,0.4v6.1\n                           C8,6.8,7.8,7,7.6,7z" }),
                            React__default['default'].createElement("path", { className: "st0", d: "M0.4,8C0.3,8,0.2,8,0.1,7.9C0,7.7,0,7.4,0.1,7.2l7-7c0.2-0.2,0.5-0.2,0.6,0c0.2,0.2,0.2,0.5,0,0.6l-7,7\n                           C0.7,8,0.6,8,0.4,8z" })))))),
            React__default['default'].createElement("img", { src: data.link_mobile, onLoad: onImageLoad, onError: onImageError, style: { display: "none" }, alt: "" }))));
};

var ListContent = function (_a) {
    var message = _a.message, sourceMessageId = _a.sourceMessageId, disableInteraction = _a.disableInteraction, textAlign = _a.textAlign, avatarPosition = _a.avatarPosition, onLoad = _a.onLoad, className = _a.className;
    var messageData = message.data;
    if (!Array.isArray(messageData))
        return null;
    var buttonData = messageData.filter(function (data) { return data.label; });
    onLoad && onLoad();
    return (React__default['default'].createElement("div", { className: classnames__default['default']("bubble-button-wrap", className) }, buttonData.map(function (data, index) {
        return (React__default['default'].createElement(ChatButton, { showLinkIcon: true, className: classnames__default['default']("bubble-button", { first: index === 0 && index !== buttonData.length - 1 }, { last: index !== 0 && index === buttonData.length - 1 }, { one: index === 0 && index === buttonData.length - 1 }, { "avatar-bottom": avatarPosition === "bottom" }, "button-multiline", className), sourceMessageId: sourceMessageId, disabled: disableInteraction, key: index, data: data, textAlign: textAlign }));
    })));
};

var NextArrow = function (props) {
    props.className; var onClick = props.onClick, disabled = props.disabled;
    return (React__default['default'].createElement("div", { className: classnames__default['default']("ft-slider-arrow-next", { disabled: disabled }), onClick: onClick },
        React__default['default'].createElement("div", { className: classnames__default['default']("ft-slider-arrow", { disabled: disabled }) },
            React__default['default'].createElement("img", { className: "arrow-image", src: ArrowNextImage__default['default'], width: 7, alt: "" }))));
};
var PrevArrow = function (props) {
    props.className; var onClick = props.onClick, disabled = props.disabled;
    return (React__default['default'].createElement("div", { className: classnames__default['default']("ft-slider-arrow-prev", { disabled: disabled }), onClick: onClick },
        React__default['default'].createElement("div", { className: classnames__default['default']("ft-slider-arrow", { disabled: disabled }) },
            React__default['default'].createElement("img", { className: "arrow-image", src: ArrowPrevImage__default['default'], width: 7, alt: "" }))));
};
var Slider = function (_a) {
    var children = _a.children, className = _a.className, marginLeft = _a.marginLeft, onChangeSlide = _a.onChangeSlide, onChangeVisibleSlides = _a.onChangeVisibleSlides, disableVisibleSlides = _a.disableVisibleSlides;
    var startXRef = React.useRef(0);
    var startScrollLeft = React.useRef(0);
    var isScrollingRef = React.useRef(false);
    var scrollBarRef = React.useRef();
    var _b = React.useState([]), newChildren = _b[0], setNewChildren = _b[1];
    var _c = React.useState(0), scrollLeft = _c[0], setScrollLeft = _c[1];
    var _d = React.useState(0), currentSlide = _d[0], setCurrentSlide = _d[1];
    var visibleSlidesRef = React.useRef([]);
    var childrenRefs = React.useRef([]);
    React.useEffect(function () {
        childrenRefs.current = [];
        var childrenArray = React__default['default'].Children.toArray(children);
        childrenArray = childrenArray.filter(function (child) {
            if (typeof child === "string") {
                return !!child.trim();
            }
            return !!child;
        });
        childrenArray = childrenArray.map(function (child, index) {
            return (React__default['default'].createElement("div", { className: classnames__default['default']("ft-slider-item", { active: index === currentSlide }), ref: function (ref) {
                    if (ref) {
                        childrenRefs.current.push(ref);
                        if (index === childrenArray.length - 1) {
                            calculateVisibleSlides();
                        }
                    }
                }, key: index, style: { marginRight: "8px", marginLeft: index === 0 ? (marginLeft || 0) + "px" : 0 } }, child));
        });
        setNewChildren(childrenArray);
    }, [children]);
    var swipeStart = function (clientX) {
        startXRef.current = clientX;
        startScrollLeft.current = scrollBarRef.current.scrollLeft;
        isScrollingRef.current = true;
    };
    var swipeMove = function (clientX) {
        if (isScrollingRef.current) {
            if (scrollBarRef.current) ;
        }
    };
    var swipeEnd = function () {
        isScrollingRef.current = false;
    };
    var maxHeight = function () {
        var max = 0;
        childrenRefs.current.forEach(function (childrenRef) {
            var childrenRect = childrenRef.getBoundingClientRect();
            max = max < childrenRect.height ? childrenRect.height : max;
        });
        return max === 0 ? "auto" : max + "px";
    };
    var calculateVisibleSlides = function () {
        if (disableVisibleSlides) {
            return;
        }
        if (scrollBarRef.current && childrenRefs.current) {
            var visibleSlides = [];
            var scrollRect = scrollBarRef.current.getBoundingClientRect();
            for (var i = 0; i < childrenRefs.current.length; i++) {
                var childrenRect = childrenRefs.current[i].getBoundingClientRect();
                var scrollLeft_1 = scrollRect.left;
                var scrollRight = scrollLeft_1 + scrollBarRef.current.clientWidth;
                var elementLeft = childrenRect.left;
                var elementRight = elementLeft + childrenRect.width;
                if (scrollLeft_1 <= elementLeft && scrollRight >= elementRight) {
                    visibleSlides.push(i);
                }
            }
            if (JSON.stringify(visibleSlidesRef.current) !== JSON.stringify(visibleSlides)) {
                visibleSlidesRef.current = visibleSlides;
                onChangeVisibleSlides && onChangeVisibleSlides(visibleSlides);
            }
        }
    };
    return (React__default['default'].createElement("div", { className: classnames__default['default']("ft-slider", className), style: { marginLeft: "-" + (marginLeft || 0) + "px" } },
        React__default['default'].createElement(PrevArrow, { disabled: scrollLeft === 0, onClick: function () {
                if (scrollBarRef.current) {
                    scrollBarRef.current.scrollLeft = scrollBarRef.current.scrollLeft - 268;
                }
            } }),
        React__default['default'].createElement("div", { className: classnames__default['default']("ft-inner-slider"), ref: scrollBarRef, onScroll: function () {
                if (scrollBarRef.current) {
                    setScrollLeft(scrollBarRef.current.scrollLeft);
                    setCurrentSlide(function (currentSlide) {
                        var nextSlide = Math.round(scrollBarRef.current.scrollLeft / 260);
                        if (currentSlide != nextSlide && onChangeSlide) {
                            onChangeSlide(nextSlide);
                        }
                        return nextSlide;
                    });
                    calculateVisibleSlides();
                }
            }, onMouseDown: function (event) {
                swipeStart(event.clientX);
            }, onMouseLeave: function (event) {
                swipeEnd();
            }, onMouseUp: function (event) {
                swipeEnd();
            }, onMouseMove: function (event) {
                swipeMove(event.clientX);
            }, onTouchStart: function (event) {
                swipeStart(event.touches[0].pageX);
            }, onTouchMove: function (event) {
                swipeMove(event.touches[0].pageX);
            }, onTouchEnd: function (event) {
                swipeEnd();
            }, onTouchCancel: function (event) {
                swipeEnd();
            } },
            React__default['default'].createElement("div", { className: "ft-slider-track", style: { height: maxHeight() } }, newChildren)),
        React__default['default'].createElement(NextArrow, { disabled: (scrollBarRef.current &&
                scrollBarRef.current.scrollWidth - scrollBarRef.current.clientWidth === scrollLeft) ||
                false, onClick: function () {
                if (scrollBarRef.current) {
                    scrollBarRef.current.scrollLeft = scrollBarRef.current.scrollLeft + 268;
                }
            } })));
};

var CarouselContent = function (_a) {
    var message = _a.message, sourceMessageId = _a.sourceMessageId, disableInteraction = _a.disableInteraction, buttonTextAlign = _a.buttonTextAlign, carouselButtonBorderRadius = _a.carouselButtonBorderRadius, useReadMore = _a.useReadMore, readMoreLine = _a.readMoreLine, showAvatar = _a.showAvatar, onLoad = _a.onLoad;
    var _b = React.useState([0]), visibleSlides = _b[0], setVisibleSlides = _b[1];
    var messageData = message.data;
    if (!Array.isArray(messageData))
        return null;
    var intl = IntlStore.getInstance().intl;
    var onClick = function (e, data) {
        e.preventDefault();
        e.stopPropagation();
        if (data.click_type === "link") {
            if (data.link_mobile) {
                if (isUrl(data.link_mobile)) {
                    openLink(data.link_mobile, data.link_pc);
                }
            }
        }
        else if (data.click_type === "text" || data.click_type === "next") {
            try {
                var messages = makeUserMessages(data.title || "", data.payload);
                var chatData = makeUserData(store.scenarioId, store.conversationId, store.messagingUserId, messages, sourceMessageId);
                store.sendMessage(chatData);
            }
            catch (e) {
                console.error(e);
            }
        }
    };
    var onClickDetails = function (e, text) {
        e.preventDefault();
        e.stopPropagation();
        webChatDialogStore.open({
            title: intl.formatMessage({ id: "i0003" }),
            message: text,
            confirmText: intl.formatMessage({ id: "i0002" }),
            textAlign: "left"
        });
    };
    var renderMedia = function (data, width, mediaOnly, active) {
        switch (data.media_type) {
            case "image":
                return (React__default['default'].createElement("div", { className: classnames__default['default']("media-container", { "media-only": mediaOnly }, "clickable-image") },
                    React__default['default'].createElement(reactBootstrap.Image, { onLoad: function () {
                            onLoad && onLoad();
                        }, onError: function () {
                            onLoad && onLoad();
                        }, src: data.media_url, onClick: function () {
                            lightBoxStore.open(data.media_url);
                        }, className: classnames__default['default']("bubble-carousel-media", { "media-only": mediaOnly }) })));
            case "video":
                onLoad && onLoad();
                return (React__default['default'].createElement("div", { className: classnames__default['default']("media-container", { "media-only": mediaOnly }) },
                    React__default['default'].createElement(ReactPlayer__default['default'], { className: classnames__default['default']("bubble-carousel-media", { "media-only": mediaOnly }, "video"), url: data.media_url, controls: active, width: width, height: 145, config: {
                            file: {
                                attributes: {
                                    controlsList: "nodownload",
                                    disablePictureInPicture: true
                                }
                            }
                        } })));
            case "audio":
                onLoad && onLoad();
                return (React__default['default'].createElement("div", { className: classnames__default['default']("media-container", { "media-only": mediaOnly }, "audio") },
                    React__default['default'].createElement(ReactPlayer__default['default'], { className: classnames__default['default']("bubble-carousel-media", { "media-only": mediaOnly }, "audio"), url: data.media_url, width: width, height: 30, controls: true, config: {
                            file: {
                                attributes: { controlsList: "nodownload", disablePictureInPicture: true }
                            }
                        } })));
        }
    };
    if (messageData.length === 1) {
        var data_1 = messageData[0];
        var description_1 = data_1.text;
        var mediaOnly = (!data_1.buttons || data_1.buttons.length === 0) && !data_1.text && !data_1.title;
        var truncatedText = description_1;
        if (useReadMore && readMoreLine && description_1) {
            truncatedText = truncateStringByLine(readMoreLine, description_1);
        }
        !data_1.media_type && onLoad && onLoad();
        return (React__default['default'].createElement("div", { className: classnames__default['default']("bubble-carousel-item"), onClick: function (event) { return onClick(event, data_1); }, style: { width: "100%" } },
            data_1.media_type && renderMedia(data_1, 260, mediaOnly),
            data_1.title && React__default['default'].createElement("div", { className: "card-title" }, data_1.title),
            description_1 && (React__default['default'].createElement("div", { className: "card-description", style: { whiteSpace: "pre-wrap", wordBreak: "break-word" } },
                React__default['default'].createElement(Linkify, null, truncatedText),
                truncatedText !== description_1 && (React__default['default'].createElement("a", { href: "#", onClick: function (event) { return onClickDetails(event, description_1); } },
                    React__default['default'].createElement("div", { className: "show-more" },
                        React__default['default'].createElement("div", null, intl.formatMessage({ id: "i0003" })),
                        React__default['default'].createElement("div", { className: "show-more-arrow" }, "＞")))))),
            React__default['default'].createElement("div", { className: "bubble-carousel-button-container" }, data_1.buttons &&
                data_1.buttons.map(function (button, index) {
                    return button.label && (React__default['default'].createElement(ChatButton, { className: classnames__default['default']("bubble-carousel-button button-multiline", {
                            first: index === 0
                        }), style: { borderRadius: carouselButtonBorderRadius }, sourceMessageId: sourceMessageId, showLinkIcon: true, disabled: disableInteraction, key: index, data: button, textAlign: buttonTextAlign }));
                }))));
    }
    else {
        var hasMedia_1 = messageData.find(function (data) {
            return !!data.media_type;
        });
        return (React__default['default'].createElement(Slider, { disableVisibleSlides: !hasMedia_1, marginLeft: showAvatar ? 40 : 0, onChangeVisibleSlides: function (values) {
                setVisibleSlides(values);
            } }, messageData.map(function (data, index) {
            var description = data.text;
            var truncatedText = description;
            if (useReadMore && readMoreLine && description) {
                truncatedText = truncateStringByLine(readMoreLine, description);
            }
            var mediaOnly = (!data.buttons || data.buttons.length === 0) && !data.text && !data.title;
            var height = mediaOnly ? "auto" : "100%";
            !hasMedia_1 && index === messageData.length - 1 && onLoad && onLoad();
            return (React__default['default'].createElement("div", { key: index, style: { height: height } },
                React__default['default'].createElement("div", { className: classnames__default['default']("bubble-carousel-item"), onClick: function (event) { return onClick(event, data); }, style: { height: height } },
                    data.media_type && renderMedia(data, 258, mediaOnly, visibleSlides.includes(index)),
                    data.title && React__default['default'].createElement("div", { className: "card-title" }, data.title),
                    description && (React__default['default'].createElement("div", { className: "card-description", style: {
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            height: "auto"
                        } },
                        React__default['default'].createElement(Linkify, null, truncatedText),
                        truncatedText !== description && (React__default['default'].createElement("a", { href: "#", onClick: function (event) { return onClickDetails(event, description); } },
                            React__default['default'].createElement("div", { className: "show-more" },
                                React__default['default'].createElement("div", null, intl.formatMessage({ id: "i0003" })),
                                React__default['default'].createElement("div", { className: "show-more-arrow" }, "＞")))))),
                    React__default['default'].createElement("div", { className: "bubble-carousel-button-container" }, data.buttons &&
                        data.buttons.map(function (button, index) {
                            return button.label && (React__default['default'].createElement(ChatButton, { sourceMessageId: sourceMessageId, className: classnames__default['default']("bubble-carousel-button button-multiline", {
                                    first: index === 0
                                }), style: { borderRadius: carouselButtonBorderRadius }, showLinkIcon: true, disabled: disableInteraction, key: index, data: button, textAlign: buttonTextAlign }));
                        })))));
        })));
    }
};

var DynamicHeightImage = function (_a) {
    var src = _a.src, width = _a.width, className = _a.className, onLoad = _a.onLoad;
    var _b = React.useState(150), height = _b[0], setHeight = _b[1];
    var _c = React.useState(src), imageSrc = _c[0], setImageSrc = _c[1];
    var imageRef = React.useRef();
    if (!src) {
        onLoad && onLoad();
        return React__default['default'].createElement("div", { className: className, style: { width: width + "px", height: "0px", visibility: "hidden" } });
    }
    return (React__default['default'].createElement("div", { className: "clickable-image" },
        React__default['default'].createElement("img", { src: imageSrc, ref: imageRef, className: classnames__default['default'](className), style: { width: width + "px", height: height + "px" }, onClick: function () {
                lightBoxStore.open(imageSrc);
            }, onLoad: function () {
                var ratio = width / imageRef.current.naturalWidth;
                var newHeight = imageRef.current.naturalHeight * ratio;
                setHeight(newHeight);
                onLoad && onLoad();
            }, onError: function () {
                setImageSrc(broken__default['default']);
                onLoad && onLoad();
            }, alt: "" })));
};

var VideoSeekSlider = styled__default['default'](ReactSlider__default['default'])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 4px;\n    left: 10px;\n    right: 10px;\n    height: 2px;\n    width: calc(100% - 20px);\n"], ["\n    margin-top: 4px;\n    left: 10px;\n    right: 10px;\n    height: 2px;\n    width: calc(100% - 20px);\n"])));
var VideoVolumeSlider = styled__default['default'](ReactSlider__default['default'])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 12px;\n    width: 30px;\n    height: 2px;\n"], ["\n    margin-top: 12px;\n    width: 30px;\n    height: 2px;\n"])));
var AudioSeekSlider = styled__default['default'](ReactSlider__default['default'])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: auto;\n    margin-top: 13px;\n    margin-bottom: 13px;\n    width: 60px;\n    height: 2px;\n"], ["\n    margin-left: auto;\n    margin-top: 13px;\n    margin-bottom: 13px;\n    width: 60px;\n    height: 2px;\n"])));
var AudioVolumeSlider = styled__default['default'](ReactSlider__default['default'])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-left: 8px;\n    margin-right: 20px;\n    margin-top: 13px;\n    margin-bottom: 13px;\n    width: 30px;\n    height: 2px;\n"], ["\n    margin-left: 8px;\n    margin-right: 20px;\n    margin-top: 13px;\n    margin-bottom: 13px;\n    width: 30px;\n    height: 2px;\n"])));
var StyledThumb = styled__default['default'].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    top: -2.5px;\n    height: 8px;\n    width: 8px;\n    text-align: center;\n    background-color: #ffffff;\n    border-radius: 50%;\n    cursor: grab;\n    outline: none;\n"], ["\n    top: -2.5px;\n    height: 8px;\n    width: 8px;\n    text-align: center;\n    background-color: #ffffff;\n    border-radius: 50%;\n    cursor: grab;\n    outline: none;\n"])));
var Thumb = function (props, state) { return React__default['default'].createElement(StyledThumb, __assign({}, props)); };
var StyledTrack = styled__default['default'].div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    top: 0;\n    bottom: 0;\n    background: ", ";\n"], ["\n    top: 0;\n    bottom: 0;\n    background: ", ";\n"])), function (props) { return (props.index === 1 ? "#7f7f7f" : "#ffffff"); });
var Track = function (props, state) { return React__default['default'].createElement(StyledTrack, __assign({}, props, { index: state.index })); };
var zeroPad = function (num, places) { return String(num).padStart(places, "0"); };
var ChatPlayer = function (_a) {
    var type = _a.type, url = _a.url, width = _a.width, height = _a.height;
    var playerRef = React.useRef();
    var _b = React.useState(false), playing = _b[0], setPlaying = _b[1];
    var _c = React.useState(false), muted = _c[0], setMuted = _c[1];
    var _d = React.useState(0.8), volume = _d[0], setVolume = _d[1];
    var _e = React.useState(0), durationSeconds = _e[0], setDurationSeconds = _e[1];
    var _f = React.useState(0), playedSeconds = _f[0], setPlayedSeconds = _f[1];
    var playedString = zeroPad(Math.round(playedSeconds / 60), 2) + ":" + zeroPad(playedSeconds % 60, 2);
    var durationString = zeroPad(Math.round(durationSeconds / 60), 2) + ":" + zeroPad(durationSeconds % 60, 2);
    if (type === "audio") {
        return (React__default['default'].createElement("div", null,
            React__default['default'].createElement(ReactPlayer__default['default'], { url: url, controls: false, width: 0, height: 0, playing: playing, muted: muted, volume: volume, onPlay: function () {
                    setPlaying(true);
                }, onPause: function () {
                    setPlaying(false);
                }, onProgress: function (state) {
                    setPlayedSeconds(Math.round(state.playedSeconds));
                }, onDuration: function (duration) {
                    setDurationSeconds(Math.round(duration));
                }, config: { file: { forceAudio: true } } }),
            React__default['default'].createElement("div", { className: "player-audio", style: { width: width ? width : "260px", height: height ? height : "28px" } },
                React__default['default'].createElement("button", { className: "button-play", onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        setPlaying(function (value) { return !value; });
                    } },
                    React__default['default'].createElement("img", { style: { display: "block" }, src: playing ? PauseIcon__default['default'] : PlayIcon__default['default'], width: 9, height: 10, alt: "" })),
                React__default['default'].createElement("div", { className: "play-time" }, playedString + " / " + durationString),
                React__default['default'].createElement(AudioSeekSlider, { defaultValue: 0, value: playedSeconds, min: 0, max: durationSeconds, renderTrack: Track, renderThumb: Thumb, onChange: function (value) {
                        setPlayedSeconds(value);
                        if (playerRef.current) {
                            playerRef.current.seekTo(value);
                        }
                    } }),
                React__default['default'].createElement("button", { className: "button-volume", onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        setMuted(function (value) { return !value; });
                    } },
                    React__default['default'].createElement("img", { style: { display: "block" }, src: muted ? VolumeMuteIcon__default['default'] : VolumeIcon__default['default'], width: 14, height: 10, alt: "" })),
                React__default['default'].createElement(AudioVolumeSlider, { defaultValue: volume * 100, value: volume * 100, min: 0, max: 100, renderTrack: Track, renderThumb: Thumb, onChange: function (value) {
                        setVolume(value / 100);
                    } }))));
    }
    return (React__default['default'].createElement("div", { style: { backgroundColor: "#eeeeee", width: width ? width : "360px" } },
        React__default['default'].createElement(ReactPlayer__default['default'], { ref: playerRef, url: url, controls: false, width: width, height: height, playing: playing, muted: muted, volume: volume, onPlay: function () {
                setPlaying(true);
            }, onPause: function () {
                setPlaying(false);
            }, onProgress: function (state) {
                setPlayedSeconds(Math.round(state.playedSeconds));
            }, onDuration: function (duration) {
                setDurationSeconds(Math.round(duration));
            } }),
        React__default['default'].createElement("div", { className: "player-video", style: { width: width ? width : "300px" } },
            React__default['default'].createElement("div", { style: { display: "flex" } },
                React__default['default'].createElement("button", { className: "button-play", onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        setPlaying(function (value) { return !value; });
                    } },
                    React__default['default'].createElement("img", { style: { display: "block" }, src: playing ? PauseIcon__default['default'] : PlayIcon__default['default'], width: 9, height: 10, alt: "" })),
                React__default['default'].createElement("div", { className: "play-time" }, playedString + " / " + durationString),
                React__default['default'].createElement("div", { className: "right-button-container" },
                    React__default['default'].createElement("button", { className: "button-volume", onClick: function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            setMuted(function (value) { return !value; });
                        } },
                        React__default['default'].createElement("img", { style: { display: "block" }, src: muted ? VolumeMuteIcon__default['default'] : VolumeIcon__default['default'], width: 14, height: 10, alt: "" })),
                    React__default['default'].createElement(VideoVolumeSlider, { defaultValue: volume * 100, value: volume * 100, min: 0, max: 100, renderTrack: Track, renderThumb: Thumb, onChange: function (value) {
                            setVolume(value / 100);
                        } }),
                    React__default['default'].createElement("button", { className: "button-fullscreen", onClick: function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if (playerRef.current) {
                                try {
                                    screenfull__default['default'].request(ReactDOM__default['default'].findDOMNode(playerRef.current));
                                }
                                catch (e) { }
                            }
                        } },
                        React__default['default'].createElement("img", { style: { display: "block" }, src: FullScreenIcon__default['default'], width: 10, height: 10, alt: "" })))),
            React__default['default'].createElement("div", null,
                React__default['default'].createElement(VideoSeekSlider, { defaultValue: 0, value: playedSeconds, min: 0, max: durationSeconds, renderTrack: Track, renderThumb: Thumb, onChange: function (value) {
                        setPlayedSeconds(value);
                        if (playerRef.current) {
                            playerRef.current.seekTo(value);
                        }
                    } })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var MediaContent = function (_a) {
    var message = _a.message, mediaWithoutBubble = _a.mediaWithoutBubble, className = _a.className, onLoad = _a.onLoad;
    var messageData = message.data || {};
    switch (messageData.media_type) {
        case "image":
            if (mediaWithoutBubble) {
                return (React__default['default'].createElement("div", { className: "clickable-image" },
                    React__default['default'].createElement(reactBootstrap.Image, { src: messageData.media_url, className: "media-image", onClick: function () {
                            lightBoxStore.open(messageData.media_url);
                        }, onLoad: function () {
                            onLoad && onLoad();
                        }, onError: function () {
                            onLoad && onLoad();
                        } })));
            }
            else {
                return (React__default['default'].createElement(DynamicHeightImage, { src: messageData.media_url, className: classnames__default['default']("bubble-image", className), width: 300, onLoad: function () {
                        onLoad && onLoad();
                    } }));
            }
        case "video":
            onLoad && onLoad();
            if (mediaWithoutBubble) {
                return React__default['default'].createElement(ChatPlayer, { type: "video", url: messageData.media_url, width: 360, height: 240 });
            }
            else {
                return React__default['default'].createElement(ChatPlayer, { type: "video", url: messageData.media_url, width: 300, height: 169 });
            }
        case "audio":
            return React__default['default'].createElement(ChatPlayer, { type: "audio", url: messageData.media_url });
    }
    onLoad && onLoad();
    return React__default['default'].createElement("div", null);
};

var FileContent = function (_a) {
    var message = _a.message;
    var messageData = message.data || {};
    return (React__default['default'].createElement("div", null,
        React__default['default'].createElement("div", { style: { whiteSpace: "pre-wrap", wordBreak: "break-word" } },
            React__default['default'].createElement(Linkify, null, messageData.text)),
        React__default['default'].createElement("div", null,
            React__default['default'].createElement(ChatButton, { className: classnames__default['default']("bubble-carousel-button", "button-multiline", "first"), data: {
                    label: messageData.label || "Download a File",
                    button_type: "link",
                    link_mobile: messageData.file_url
                }, textAlign: "left" }))));
};

var CustomItem = function (_a) {
    var item = _a.item, onChangeInput = _a.onChangeInput, onClickSubmitBtn = _a.onClickSubmitBtn, onClickCancelBtn = _a.onClickCancelBtn, onChangeRating = _a.onChangeRating, disableSubmitButton = _a.disableSubmitButton;
    var _b = React.useState(5), ratingValue = _b[0], setRatingValue = _b[1];
    switch (item.type) {
        case "text":
            return (React__default['default'].createElement("div", { className: "text" },
                React__default['default'].createElement(Linkify, null, item.text)));
        case "key-value":
            return (React__default['default'].createElement("div", null, (item.items || []).map(function (listItem, index) {
                return (React__default['default'].createElement("div", { style: { display: "flex" }, key: "key-value-item" + index },
                    React__default['default'].createElement("div", { className: "text", style: { marginRight: "4px" } },
                        React__default['default'].createElement(Linkify, null, listItem.key)),
                    React__default['default'].createElement("div", { className: "text" },
                        React__default['default'].createElement(Linkify, null, listItem.value))));
            })));
        case "image":
            if (item.image_type === "center") {
                return (React__default['default'].createElement("div", { style: { display: "flex", justifyContent: "center" } },
                    React__default['default'].createElement(reactBootstrap.Image, { className: "center-image", src: item.url, width: item.width, height: item.height })));
            }
            else {
                return React__default['default'].createElement(reactBootstrap.Image, { className: "large-image", src: item.url });
            }
        case "list":
            return (React__default['default'].createElement("div", null, (item.items || []).map(function (listItem, index) {
                return (React__default['default'].createElement("div", { key: "list-item" + index, className: "list-item", onClick: function () {
                        if (listItem.action && listItem.action.type === "send") {
                            var messages = makeUserMessages(listItem.action.text || listItem.title || listItem.description, listItem.action.payload);
                            var chatData = makeUserData(store.scenarioId, store.conversationId, store.messagingUserId, messages);
                            store.sendMessage(chatData);
                        }
                        else if (listItem.action && listItem.action.type === "link") {
                            window.open(listItem.action.url, "_blank");
                        }
                    } },
                    (index === 0 && item.divider_top && item.divider_top.image && (React__default['default'].createElement(reactBootstrap.Image, { src: item.divider_top.image, style: {
                            display: "block",
                            height: item.divider_top.height || "2px",
                            width: "100%"
                        } }))) ||
                        (index === 0 && item.divider_top && (React__default['default'].createElement("div", { style: {
                                height: item.divider_top.height,
                                backgroundColor: item.divider_top.background_color,
                                backgroundImage: item.divider_top.background_image
                            } }))),
                    React__default['default'].createElement("div", { style: {
                            display: "flex",
                            height: listItem.height,
                            backgroundColor: listItem.background_color
                        } },
                        listItem.image && (React__default['default'].createElement("div", { style: {
                                alignSelf: "center",
                                marginRight: "4px"
                            } },
                            React__default['default'].createElement(reactBootstrap.Image, { className: "small-image", src: listItem.image }))),
                        React__default['default'].createElement("div", { style: { alignSelf: "center" } },
                            listItem.title && (React__default['default'].createElement("div", { className: "text", style: {
                                    marginBottom: listItem.description ? "4px" : "0px"
                                } },
                                React__default['default'].createElement(Linkify, null, listItem.title))),
                            listItem.description && (React__default['default'].createElement("div", { className: "text" },
                                React__default['default'].createElement(Linkify, null, listItem.description)))),
                        listItem.tail_image && (React__default['default'].createElement("div", { style: {
                                alignSelf: "center",
                                marginLeft: "auto"
                            } },
                            React__default['default'].createElement(reactBootstrap.Image, { src: listItem.tail_image, width: listItem.tail_image_width, height: listItem.tail_image_height })))),
                    index + 1 < item.items.length && item.divider && (React__default['default'].createElement("div", { style: {
                            height: item.divider.height,
                            backgroundColor: item.divider.background_color,
                            backgroundImage: item.divider.background_image
                        } })),
                    (index + 1 === item.items.length &&
                        item.divider_bottom &&
                        item.divider_bottom.image && (React__default['default'].createElement(reactBootstrap.Image, { src: item.divider_bottom.image, style: {
                            display: "block",
                            height: item.divider_bottom.height || "2px",
                            width: "100%"
                        } }))) ||
                        (index + 1 === item.items.length && item.divider_bottom && (React__default['default'].createElement("div", { style: {
                                height: item.divider_bottom.height,
                                backgroundColor: item.divider_bottom.background_color,
                                backgroundImage: item.divider_bottom.background_image
                            } })))));
            })));
        case "divider":
            if (item.image) {
                return (React__default['default'].createElement(reactBootstrap.Image, { className: "divider-image", src: item.image, style: { display: "block", height: item.height || "2px" } }));
            }
            return (React__default['default'].createElement("div", { className: "divider", style: { height: item.height || "2px", backgroundColor: item.background_color || "#dadada" } }));
        case "rating":
            onChangeRating(ratingValue);
            return (React__default['default'].createElement("div", { style: { display: "flex", justifyContent: "center", width: "100%" } },
                React__default['default'].createElement(ReactStars__default['default'], { value: ratingValue, count: 5, onChange: function (value) {
                        setRatingValue(value);
                        onChangeRating(value);
                    }, size: 40, color2: "#ffd700" })));
        case "input":
            return (React__default['default'].createElement("div", null,
                React__default['default'].createElement("div", { className: "text" },
                    React__default['default'].createElement(Linkify, null, item.label)),
                React__default['default'].createElement("input", { type: "text", placeholder: item.placeholder, onChange: function (event) {
                        onChangeInput(item.key, event.currentTarget.value);
                    }, style: { width: "100%" } })));
        case "button":
            return (React__default['default'].createElement("button", { className: classnames__default['default']("button", {
                    dim: item.action && item.action.type === "submit" && disableSubmitButton
                }), disabled: item.action && item.action.type === "submit" && disableSubmitButton, onClick: function (event) {
                    if (item.action && item.action.type === "send") {
                        var messages = makeUserMessages(item.action.text || item.label, item.action.payload);
                        var chatData = makeUserData(store.scenarioId, store.conversationId, store.messagingUserId, messages);
                        store.sendMessage(chatData);
                    }
                    else if (item.action && item.action.type === "link") {
                        window.open(item.action.url, "_blank");
                    }
                    else if (item.action && item.action.type === "submit") {
                        onClickSubmitBtn(event, item.action.post_url);
                    }
                    else if (item.action && item.action.type === "cancel") {
                        onClickCancelBtn(event);
                    }
                } }, item.label));
        case "button-custom":
            return (React__default['default'].createElement("button", { className: classnames__default['default']("button-custom"), onClick: function (event) {
                    if (item.action && item.action.type === "send") {
                        var messages = makeUserMessages(item.action.text || item.label, item.action.payload);
                        var chatData = makeUserData(store.scenarioId, store.conversationId, store.messagingUserId, messages);
                        store.sendMessage(chatData);
                    }
                    else if (item.action && item.action.type === "link") {
                        window.open(item.action.url, "_blank");
                    }
                    else if (item.action && item.action.type === "submit") {
                        onClickSubmitBtn(event, item.action.post_url);
                    }
                    else if (item.action && item.action.type === "cancel") {
                        onClickCancelBtn(event);
                    }
                }, style: { height: item.height || "30px", width: item.width || "100%" } },
                item.label && React__default['default'].createElement(Linkify, null, item.label),
                item.image && (React__default['default'].createElement(reactBootstrap.Image, { src: item.image, style: {
                        display: "block",
                        height: item.image_height || "100%",
                        width: item.image_width || "100%"
                    } }))));
        default:
            return React__default['default'].createElement("div", null, item.type);
    }
};

var CustomBubbleContent = function (_a) {
    var data = _a.data, onClickSubmitBtn = _a.onClickSubmitBtn, disableSubmitButton = _a.disableSubmitButton, onChangeInput = _a.onChangeInput, onChangeRating = _a.onChangeRating, onClickCancelBtn = _a.onClickCancelBtn;
    return (React__default['default'].createElement("div", { className: "chat-custom-ui" }, data.map(function (item, index) {
        return (React__default['default'].createElement("div", { className: "chat-custom-item", key: "item" + index },
            React__default['default'].createElement(CustomItem, { item: item, onChangeInput: onChangeInput, onClickSubmitBtn: onClickSubmitBtn, onClickCancelBtn: onClickCancelBtn, disableSubmitButton: disableSubmitButton, onChangeRating: onChangeRating })));
    })));
};

var CustomWithoutBubbleContent = function (_a) {
    var data = _a.data, windowWidth = _a.windowWidth, disableSubmitButton = _a.disableSubmitButton, onChangeInput = _a.onChangeInput, onChangeRating = _a.onChangeRating, onClickCancelBtn = _a.onClickCancelBtn, onClickSubmitBtn = _a.onClickSubmitBtn, backgroundColor = _a.backgroundColor;
    return (React__default['default'].createElement("div", { className: "chat-custom-ui-container", style: { width: windowWidth, backgroundColor: backgroundColor } },
        React__default['default'].createElement("div", { className: "chat-custom-ui" }, data.map(function (item, index) {
            return (React__default['default'].createElement("div", { className: "chat-custom-item", key: "item" + index },
                React__default['default'].createElement(CustomItem, { item: item, onChangeInput: onChangeInput, onClickSubmitBtn: onClickSubmitBtn, onClickCancelBtn: onClickCancelBtn, disableSubmitButton: disableSubmitButton, onChangeRating: onChangeRating })));
        }))));
};

var CustomContent = function (_a) {
    var message = _a.message, windowWidth = _a.windowWidth;
    var _b = React.useState(false), disableSubmitButton = _b[0], setDisableSubmitButton = _b[1];
    var inputValueRef = React.useRef({});
    var customData = message.data || { type: undefined, data: [], background_color: undefined };
    var backgroundColor = customData.background_color;
    var type = customData.type;
    var data = customData.data || {};
    var onClickCancelBtn = function () { };
    var onChangeInput = function (key, value) {
        inputValueRef.current[key] = value;
    };
    var onChangeRatingValue = function (value) {
        inputValueRef.current.rating_value = value;
    };
    var onClickSubmitBtn = function (event, postUrl) {
        submitCustomData(postUrl, inputValueRef.current).then(function () {
            setDisableSubmitButton(true);
        });
    };
    if (type === "custom-ui-bubble") {
        return (React__default['default'].createElement(CustomBubbleContent, { data: data, disableSubmitButton: disableSubmitButton, onClickSubmitBtn: onClickSubmitBtn, onClickCancelBtn: onClickCancelBtn, onChangeInput: onChangeInput, onChangeRating: onChangeRatingValue }));
    }
    else if (type === "custom-ui-without-bubble") {
        return (React__default['default'].createElement(CustomWithoutBubbleContent, { data: data, windowWidth: windowWidth, disableSubmitButton: disableSubmitButton, onClickSubmitBtn: onClickSubmitBtn, onClickCancelBtn: onClickCancelBtn, onChangeInput: onChangeInput, onChangeRating: onChangeRatingValue, backgroundColor: backgroundColor }));
    }
    else {
        return React__default['default'].createElement("div", null, "Custom UI");
    }
};

var QuickReplyContent = function (_a) {
    var message = _a.message, sourceMessageId = _a.sourceMessageId, disableInteraction = _a.disableInteraction, showAvatar = _a.showAvatar, onLoad = _a.onLoad;
    var messageData = message.data;
    if (!Array.isArray(messageData))
        return null;
    return (React__default['default'].createElement(Slider, { marginLeft: showAvatar ? 40 : 0, disableVisibleSlides: true }, messageData.map(function (data, index) {
        return (data.label && (React__default['default'].createElement(ChatButton, { className: "suggestion-button button-multiline", sourceMessageId: sourceMessageId, disabled: disableInteraction, key: index, data: data, onLoad: function () {
                if (index == messageData.length - 1) {
                    onLoad && onLoad();
                }
            } })));
    })));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && ('object' !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));
});

createCommonjsModule(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment) :
   factory(global.moment);
}(commonjsGlobal, (function (moment) {

    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));
});

var messageComponent = function (windowWidth, message, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, props, messageInfo, className) {
    var data_type = message.data_type, text = message.text;
    if (data_type === "text" || text) {
        return (React__default['default'].createElement(TextContent, { message: message, useReadMore: props && props.useReadMore, readMoreLine: props && props.readMoreLine, onLoad: props && props.onLoad }));
    }
    else if (data_type === "list") {
        return (React__default['default'].createElement(ListContent, { message: message, sourceMessageId: messageInfo && messageInfo.id, disableInteraction: disableInteraction, textAlign: buttonTextAlign, avatarPosition: props && props.avatarPosition, onLoad: props && props.onLoad, className: className }));
    }
    else if (data_type === "quick_reply") {
        return (React__default['default'].createElement(QuickReplyContent, { message: message, sourceMessageId: messageInfo && messageInfo.id, disableInteraction: disableInteraction, showAvatar: props && props.showAvatar, onLoad: props && props.onLoad }));
    }
    else if (data_type === "carousel") {
        return (React__default['default'].createElement(CarouselContent, { message: message, sourceMessageId: messageInfo && messageInfo.id, disableInteraction: disableInteraction, buttonTextAlign: carouselButtonTextAlign, carouselButtonBorderRadius: carouselButtonBorderRadius, useReadMore: props && props.useReadMore, readMoreLine: props && props.readMoreLine, showAvatar: props && props.showAvatar, onLoad: props && props.onLoad }));
    }
    else if (data_type === "media") {
        if (!lodash.isArray(message.data)) {
            return (React__default['default'].createElement(MediaContent, { message: message, mediaWithoutBubble: mediaWithoutBubble, className: className, onLoad: props && props.onLoad }));
        }
    }
    else if (data_type === "custom") {
        return React__default['default'].createElement(CustomContent, { message: message, windowWidth: windowWidth });
    }
    else if (data_type === "file") {
        return React__default['default'].createElement(FileContent, { message: message });
    }
};
var CustomToggle = React__default['default'].forwardRef(function (_a, ref) {
    var children = _a.children, onClick = _a.onClick;
    return (React__default['default'].createElement("button", { ref: ref, onClick: function (event) {
            event.preventDefault();
            onClick(event);
        } }, children));
});
var ChatBubble = function (_a) {
    var message = _a.message, isOwn = _a.isOwn, disableInteraction = _a.disableInteraction, index = _a.index, isLast = _a.isLast, inputMessage = _a.inputMessage, isBotMessage = _a.isBotMessage, showAvatar = _a.showAvatar, avatarPosition = _a.avatarPosition, createdAt = _a.createdAt, mediaWithoutBubble = _a.mediaWithoutBubble, buttonTextAlign = _a.buttonTextAlign, carouselButtonTextAlign = _a.carouselButtonTextAlign, carouselButtonBorderRadius = _a.carouselButtonBorderRadius, useReadMore = _a.useReadMore, readMoreLine = _a.readMoreLine, messageInfo = _a.messageInfo, style = _a.style, colors = _a.colors, onLoad = _a.onLoad, windowWidth = _a.windowWidth;
    var intl = IntlStore.getInstance().intl;
    var isCarousel = message.data_type === "carousel";
    var isMedia = message.data_type === "media";
    var isRenderMediaWithoutBubble = mediaWithoutBubble && message.data_type === "media";
    var isRenderWithoutBubble = isCarousel ||
        isRenderMediaWithoutBubble ||
        (message.data_type === "custom" && message.data && message.data.type === "custom-ui-without-bubble");
    var renderMessage = function () {
        return (React__default['default'].createElement("div", { className: classnames__default['default']("message-container", {
                odd: isOwn,
                // last: isLast,
                sending: messageInfo && messageInfo.status === "sending"
            }), style: style },
            React__default['default'].createElement("div", null,
                React__default['default'].createElement("div", { className: classnames__default['default']("chat-bubble", {
                        first: index === 0 && (!avatarPosition || avatarPosition === "top" || isOwn)
                    }, { last: isLast && avatarPosition === "bottom" }, { odd: isOwn }, { media: isMedia }) },
                    React__default['default'].createElement("div", { className: classnames__default['default']({ "bubble-wrap": true }, { odd: isOwn }) },
                        messageComponent(windowWidth, message, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, { useReadMore: useReadMore, readMoreLine: readMoreLine, colors: colors, avatarPosition: avatarPosition, showAvatar: showAvatar, onLoad: onLoad }, messageInfo, classnames__default['default']({
                            first: index === 0 && (!avatarPosition || avatarPosition === "top" || isOwn)
                        }, { last: isLast && avatarPosition === "bottom" }, { odd: isOwn })),
                        inputMessage &&
                            inputMessage.data_type === "list" &&
                            messageComponent(windowWidth, inputMessage, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, { useReadMore: useReadMore, readMoreLine: readMoreLine, colors: colors, avatarPosition: avatarPosition, showAvatar: showAvatar, onLoad: onLoad }, messageInfo)))),
            messageInfo && messageInfo.status && messageInfo.status === "failed" && (React__default['default'].createElement("div", { className: "chat-send-failed" },
                React__default['default'].createElement(reactBootstrap.Dropdown, { drop: "left" },
                    React__default['default'].createElement(reactBootstrap.Dropdown.Toggle, { as: CustomToggle, id: "dropdown-custom-components" }, "!"),
                    React__default['default'].createElement(reactBootstrap.Dropdown.Menu, null,
                        React__default['default'].createElement(reactBootstrap.Dropdown.Item, { onClick: function () {
                                if (messageInfo) {
                                    store.updateMessageStatus(messageInfo.id, "sending");
                                    store.sendMessage(messageInfo);
                                }
                            } }, intl.formatMessage({ id: "i0006" })),
                        React__default['default'].createElement(reactBootstrap.Dropdown.Item, { onClick: function () {
                                messageInfo && messageInfo.id && store.deleteMessage(messageInfo.id);
                            } }, intl.formatMessage({ id: "i0007" })))))),
            isOwn && React__default['default'].createElement("div", { className: "chat-time" }, moment__default['default'].utc(createdAt).local().format("LT"))));
    };
    var renderBotMessage = function (withoutBubble) {
        var isFirst = index === 0 && (!avatarPosition || avatarPosition === "top" || isOwn);
        if (message.type === "input") {
            return React__default['default'].createElement("div", null);
        }
        return (React__default['default'].createElement("div", { className: classnames__default['default']("message-container", {
                odd: isOwn,
                "without-bubble": withoutBubble
            }), style: style },
            React__default['default'].createElement("div", { style: { width: "100%" } },
                withoutBubble && (React__default['default'].createElement("div", { style: {
                        width: "100%",
                        marginTop: isFirst ? "0px" : "8px"
                    } }, messageComponent(windowWidth, message, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, { useReadMore: useReadMore, readMoreLine: readMoreLine, colors: colors, avatarPosition: avatarPosition, showAvatar: showAvatar, onLoad: onLoad }, messageInfo))),
                (!withoutBubble || (inputMessage && inputMessage.data_type === "list")) && (React__default['default'].createElement("div", { className: classnames__default['default']("chat-bubble", {
                        first: isFirst && !withoutBubble
                    }, { last: isLast && avatarPosition === "bottom" }, { odd: isOwn }, { media: isMedia }) },
                    React__default['default'].createElement("div", { className: classnames__default['default']({ "bubble-wrap": message.data_type !== "media" }, { odd: isOwn }) },
                        !withoutBubble &&
                            messageComponent(windowWidth, message, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, { useReadMore: useReadMore, readMoreLine: readMoreLine, colors: colors, avatarPosition: avatarPosition, showAvatar: showAvatar, onLoad: onLoad }, messageInfo, classnames__default['default']({
                                first: isFirst
                            }, { last: isLast && avatarPosition === "bottom" }, { odd: isOwn })),
                        inputMessage &&
                            inputMessage.data_type === "list" &&
                            messageComponent(windowWidth, inputMessage, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, { useReadMore: useReadMore, readMoreLine: readMoreLine, colors: colors, avatarPosition: avatarPosition, showAvatar: showAvatar, onLoad: onLoad }, messageInfo, classnames__default['default']({ "no-content": withoutBubble }))))))));
    };
    return (React__default['default'].createElement("div", { className: classnames__default['default']("bubble-container", { odd: isOwn }) },
        isBotMessage ? renderBotMessage(isRenderWithoutBubble) : renderMessage(),
        inputMessage && inputMessage.data_type === "quick_reply" && (React__default['default'].createElement("div", { style: { width: "100%", marginTop: "8px" } }, messageComponent(windowWidth, inputMessage, disableInteraction, mediaWithoutBubble, buttonTextAlign, carouselButtonTextAlign, carouselButtonBorderRadius, { useReadMore: useReadMore, readMoreLine: readMoreLine, colors: colors, avatarPosition: avatarPosition, showAvatar: showAvatar, onLoad: onLoad }, messageInfo)))));
};

var FeedbackGood = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color, fill = _a.fill, onClick = _a.onClick;
    if (fill) {
        return (React__default['default'].createElement("svg", { className: className, style: style, viewBox: "0 0 32 32", onClick: onClick },
            React__default['default'].createElement("rect", { width: "32", height: "32", style: { fill: "none" } }),
            React__default['default'].createElement("g", null,
                React__default['default'].createElement("g", null,
                    React__default['default'].createElement("g", null,
                        React__default['default'].createElement("path", { style: {
                                fill: color || "#FF557A"
                            }, d: "M25.54,25.68c0.95,0,1.71-0.74,1.71-1.65s-0.77-1.65-1.71-1.65h1.25c0.95,0,1.71-0.74,1.71-1.65\n\t\t\t\ts-0.77-1.65-1.71-1.65c0.95,0,1.71-0.74,1.71-1.65s-0.77-1.65-1.71-1.65c0.95,0,1.71-0.74,1.71-1.65s-0.77-1.65-1.71-1.65h-7.65\n\t\t\t\tc0,0,0.93-1.13,0.93-2.66c0-1.1,0-1.89,0-1.89c0-0.91-0.77-1.65-1.71-1.65s-1.71,0.74-1.71,1.65c0,4.01-4.1,6.47-4.1,6.47h-1.77\n\t\t\t\tv9.65h2.14c0,0,1.4,1.6,3.64,1.6S25.54,25.68,25.54,25.68z" })),
                    React__default['default'].createElement("path", { style: {
                            fill: color || "#FF557A"
                        }, d: "M8.4,25.62H4.5c-0.55,0-1-0.45-1-1v-10.8c0-0.55,0.45-1,1-1h3.9c0.55,0,1,0.45,1,1v10.8\n\t\t\tC9.4,25.17,8.95,25.62,8.4,25.62z" })))));
    }
    return (React__default['default'].createElement("svg", { className: className, style: style, viewBox: "0 0 32 32", onClick: onClick },
        React__default['default'].createElement("rect", { width: "32", height: "32", style: { fill: "none" } }),
        React__default['default'].createElement("g", null,
            React__default['default'].createElement("g", null,
                React__default['default'].createElement("g", null,
                    React__default['default'].createElement("path", { style: {
                            fill: "none",
                            stroke: color || "#FF557A",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }, d: "M25.79,25.68c0.95,0,1.71-0.74,1.71-1.65s-0.77-1.65-1.71-1.65h1.25c0.95,0,1.71-0.74,1.71-1.65\n\t\t\t\ts-0.77-1.65-1.71-1.65c0.95,0,1.71-0.74,1.71-1.65s-0.77-1.65-1.71-1.65c0.95,0,1.71-0.74,1.71-1.65s-0.77-1.65-1.71-1.65h-7.65\n\t\t\t\tc0,0,0.93-1.13,0.93-2.66c0-1.1,0-1.89,0-1.89c0-0.91-0.77-1.65-1.71-1.65S16.9,7.02,16.9,7.93c0,4.01-4.1,6.47-4.1,6.47h-1.77\n\t\t\t\tv9.65h2.14c0,0,1.4,1.6,3.64,1.6S25.79,25.68,25.79,25.68z" })),
                React__default['default'].createElement("path", { style: {
                        fill: "none",
                        stroke: color || "#FF557A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 10
                    }, d: "M8.15,25.62h-3.9c-0.55,0-1-0.45-1-1v-10.8c0-0.55,0.45-1,1-1h3.9c0.55,0,1,0.45,1,1v10.8\n\t\t\tC9.15,25.17,8.7,25.62,8.15,25.62z" })))));
};
var FeedbackBad = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color, fill = _a.fill, onClick = _a.onClick;
    if (fill) {
        return (React__default['default'].createElement("svg", { className: className, style: style, viewBox: "0 0 32 32", onClick: onClick },
            React__default['default'].createElement("rect", { width: "32", height: "32", style: { fill: "none" } }),
            React__default['default'].createElement("g", null,
                React__default['default'].createElement("g", null,
                    React__default['default'].createElement("g", null,
                        React__default['default'].createElement("path", { style: {
                                fill: color || "#FF557A"
                            }, d: "M6.46,6.32c-0.95,0-1.71,0.74-1.71,1.65s0.77,1.65,1.71,1.65H5.21c-0.95,0-1.71,0.74-1.71,1.65\n\t\t\t\ts0.77,1.65,1.71,1.65c-0.95,0-1.71,0.74-1.71,1.65s0.77,1.65,1.71,1.65c-0.95,0-1.71,0.74-1.71,1.65s0.77,1.65,1.71,1.65h7.65\n\t\t\t\tc0,0-0.93,1.13-0.93,2.66c0,1.1,0,1.89,0,1.89c0,0.91,0.77,1.65,1.71,1.65s1.71-0.74,1.71-1.65c0-4.01,4.1-6.47,4.1-6.47h1.77\n\t\t\t\tV7.95h-2.14c0,0-1.4-1.6-3.64-1.6S6.46,6.32,6.46,6.32z" })),
                    React__default['default'].createElement("path", { style: {
                            fill: color || "#FF557A"
                        }, d: "M23.6,6.38h3.9c0.55,0,1,0.45,1,1v10.8c0,0.55-0.45,1-1,1h-3.9c-0.55,0-1-0.45-1-1V7.38\n\t\t\tC22.6,6.83,23.05,6.38,23.6,6.38z" })))));
    }
    return (React__default['default'].createElement("svg", { className: className, style: style, viewBox: "0 0 32 32", onClick: onClick },
        React__default['default'].createElement("rect", { width: "32", height: "32", style: { fill: "none" } }),
        React__default['default'].createElement("g", null,
            React__default['default'].createElement("g", null,
                React__default['default'].createElement("g", null,
                    React__default['default'].createElement("path", { style: {
                            fill: "none",
                            stroke: color || "#FF557A",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }, d: "M6.21,6.32c-0.95,0-1.71,0.74-1.71,1.65s0.77,1.65,1.71,1.65H4.96c-0.95,0-1.71,0.74-1.71,1.65\n\t\t\t\t\ts0.77,1.65,1.71,1.65c-0.95,0-1.71,0.74-1.71,1.65s0.77,1.65,1.71,1.65c-0.95,0-1.71,0.74-1.71,1.65s0.77,1.65,1.71,1.65h7.65\n\t\t\t\t\tc0,0-0.93,1.13-0.93,2.66c0,1.1,0,1.89,0,1.89c0,0.91,0.77,1.65,1.71,1.65s1.71-0.74,1.71-1.65c0-4.01,4.1-6.47,4.1-6.47h1.77\n\t\t\t\t\tV7.95h-2.14c0,0-1.4-1.6-3.64-1.6S6.21,6.32,6.21,6.32z" })),
                React__default['default'].createElement("path", { style: {
                        fill: "none",
                        stroke: color || "#FF557A",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 10
                    }, d: "M23.85,6.38h3.9c0.55,0,1,0.45,1,1v10.8c0,0.55-0.45,1-1,1h-3.9c-0.55,0-1-0.45-1-1V7.38\n\t\t\t\tC22.85,6.83,23.3,6.38,23.85,6.38z" })))));
};
var FeedbackGoodButton = function (_a) {
    var onClick = _a.onClick, color = _a.color, activeColor = _a.activeColor;
    var _b = React.useState(false), hover = _b[0], setHover = _b[1];
    var _c = React.useState(false), active = _c[0], setActive = _c[1];
    var isOn = hover || active;
    return (React__default['default'].createElement("div", { style: {
            cursor: "pointer",
            display: "block",
            textAlign: "center",
            alignSelf: "center"
        }, onClick: function (event) {
            onClick && onClick(event);
            setActive(true);
        }, onMouseEnter: function () {
            setHover(true);
        }, onMouseLeave: function () {
            setHover(false);
        } },
        React__default['default'].createElement(FeedbackGood, { style: { width: "28px", height: "28px" }, fill: isOn, color: !isOn ? color : activeColor }),
        React__default['default'].createElement("div", { style: {
                fontSize: "10px",
                height: "16px",
                color: !isOn ? color : activeColor
            } }, "\uC801\uC808\uD574\uC694")));
};
var FeedbackBadButton = function (_a) {
    var onClick = _a.onClick, color = _a.color, activeColor = _a.activeColor;
    var _b = React.useState(false), hover = _b[0], setHover = _b[1];
    var _c = React.useState(false), active = _c[0], setActive = _c[1];
    var isOn = hover || active;
    return (React__default['default'].createElement("div", { style: {
            cursor: "pointer",
            display: "block",
            textAlign: "center",
            alignSelf: "center"
        }, onClick: function (event) {
            onClick && onClick(event);
            setActive(true);
        }, onMouseEnter: function () {
            setHover(true);
        }, onMouseLeave: function () {
            setHover(false);
        } },
        React__default['default'].createElement(FeedbackBad, { style: { width: "28px", height: "28px" }, color: !isOn ? color : activeColor, fill: isOn }),
        React__default['default'].createElement("div", { style: {
                fontSize: "10px",
                height: "16px",
                color: !isOn ? color : activeColor
            } }, "\uC801\uC808\uCE58 \uC54A\uC544\uC694")));
};

var BubbleLoader = function (_a) {
    var color = _a.color;
    return (React__default['default'].createElement("div", { className: classnames__default['default']("bubble-loader") },
        React__default['default'].createElement(reactSpinners.BeatLoader, { css: "align-self: center; height: 15px;", color: color, loading: true, size: 10 })));
};

var messageInfoIds = [];
var ChatBubbleGroup = function (_a) {
    var messageInfo = _a.messageInfo, forwardedRef = _a.forwardedRef, style = _a.style, disableInteraction = _a.disableInteraction, active = _a.active, focus = _a.focus, showAvatar = _a.showAvatar, avatarUrl = _a.avatarUrl, emotionAvatar = _a.emotionAvatar, avatarPosition = _a.avatarPosition, avatarSize = _a.avatarSize, avatarName = _a.avatarName, roundAvatar = _a.roundAvatar, reverseOwner = _a.reverseOwner, mediaWithoutBubble = _a.mediaWithoutBubble, buttonTextAlign = _a.buttonTextAlign, carouselButtonTextAlign = _a.carouselButtonTextAlign, carouselButtonBorderRadius = _a.carouselButtonBorderRadius, hideCustomUIMessage = _a.hideCustomUIMessage, useReadMore = _a.useReadMore, readMoreLine = _a.readMoreLine, scrollToBottom = _a.scrollToBottom, messageDelay = _a.messageDelay; _a.isWelcome; var showDate = _a.showDate, feedbackMessage = _a.feedbackMessage, isLast = _a.isLast, scrollbar = _a.scrollbar, showFeedbackCollector = _a.showFeedbackCollector, colors = _a.colors, windowWidth = _a.windowWidth, index = _a.index;
    var intervalRef = React.useRef();
    var shouldScrollToBottomRef = React.useRef(false);
    var _b = React.useState(false), showFeedbackModal = _b[0], setShowFeedbackModal = _b[1];
    var _c = React.useState(), feedbackResult = _c[0], setFeedbackResult = _c[1];
    var delayTime = typeof messageDelay === "string" ? parseFloat(messageDelay) : messageDelay || 0;
    var isNewMessage = (messageInfo.id && !messageInfoIds.includes(messageInfo.id)) || false;
    var isBotMessage = messageInfo.sender && messageInfo.sender.type !== "user";
    var isConsultant = messageInfo.sender && messageInfo.sender.type === "consultant";
    var displayAvatarName = (isConsultant && messageInfo.sender && messageInfo.sender.name) || avatarName;
    if (isNewMessage) {
        messageInfo.id && messageInfoIds.push(messageInfo.id);
    }
    var messages = messageInfo.messages || [];
    var isOwn = (messageInfo.sender && messageInfo.sender.type === "user") || false;
    if (reverseOwner) {
        isOwn = !isOwn;
    }
    var inputMessage = messages.find(function (message) { return message.type === "input"; });
    var filteredMessage = messages.filter(function (message) {
        var isEmptyTextMessage = false;
        if (message.type === "output" && message.data_type === "text") {
            if (!message.data) {
                isEmptyTextMessage = true;
            }
            else {
                if (Array.isArray(message.data)) {
                    if (!message.data[0] || !message.data[0].text || message.data[0].text.length === 0) {
                        isEmptyTextMessage = true;
                    }
                }
                else {
                    if (!message.data.text || !message.text || message.text.length === 0) {
                        isEmptyTextMessage = true;
                    }
                }
            }
        }
        var isHideCustomMessage = hideCustomUIMessage && message.data_type === "custom";
        return (!!message.text || !!(message.data && message.data.text) ||
            (message.data_type && !(message.type === "input" || isHideCustomMessage || isEmptyTextMessage)));
    });
    if (inputMessage) {
        filteredMessage.push(inputMessage);
    }
    var useDelayMessage = delayTime > 0 && isNewMessage && isBotMessage;
    var _d = React.useState(useDelayMessage ? [] : filteredMessage), displayMessages = _d[0], setDisplayMessages = _d[1];
    var setNextDisplayMessages = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (inputMessage && filteredMessage.length < 3) {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = undefined;
                }
                setDisplayMessages(filteredMessage);
            }
            else {
                setDisplayMessages(function (displayMessages) {
                    if (displayMessages.length < filteredMessage.length) {
                        if (inputMessage && filteredMessage.length - displayMessages.length === 2) {
                            if (intervalRef.current) {
                                clearInterval(intervalRef.current);
                                intervalRef.current = undefined;
                            }
                            return __spreadArrays(displayMessages, [
                                filteredMessage[displayMessages.length],
                                filteredMessage[displayMessages.length + 1]
                            ]);
                        }
                        return __spreadArrays(displayMessages, [filteredMessage[displayMessages.length]]);
                    }
                    else {
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                            intervalRef.current = undefined;
                        }
                        return filteredMessage;
                    }
                });
            }
            shouldScrollToBottomRef.current = true;
            return [2 /*return*/];
        });
    }); };
    React.useEffect(function () {
        if (useDelayMessage) {
            if (!intervalRef.current) {
                intervalRef.current = setInterval(function () {
                    setNextDisplayMessages();
                }, delayTime * 1000);
            }
        }
    }, [filteredMessage]);
    if (filteredMessage.length === 0) {
        return React__default['default'].createElement("div", null);
    }
    var hasWithoutBubble = !!filteredMessage.find(function (message) {
        return (message.data_type === "carousel" && Array.isArray(message.data) && message.data.length > 1) ||
            (mediaWithoutBubble && message.data_type === "media") ||
            message.data_type === "quick_reply";
    });
    var isCustomWithoutBubble = messages.length > 0 &&
        messages[0].data_type === "custom" &&
        messages[0].data &&
        messages[0].data.type === "custom-ui-without-bubble";
    var hasInputMessage = !!inputMessage;
    var hasQuickReply = false;
    if (hasInputMessage &&
        inputMessage &&
        inputMessage.data_type === "quick_reply" &&
        inputMessage.data &&
        Array.isArray(inputMessage.data) &&
        inputMessage.data.length > 0) {
        hasQuickReply = true;
    }
    var avatarNameStyle = {
        position: "absolute",
        zIndex: 99,
        color: (colors && colors.avatarNameTextColor) || "gray",
        fontSize: "13px",
        fontFamily: "Noto Sans KR, Arial, sans-serif",
        textAlign: "center"
    };
    if (avatarPosition === "bottom") {
        avatarNameStyle.position = "relative";
        avatarNameStyle.left = 0;
        avatarNameStyle.width = avatarSize;
        avatarNameStyle.whiteSpace = "pre-wrap";
        avatarNameStyle.lineHeight = "0.9";
        avatarNameStyle.marginBottom = "8px";
        avatarNameStyle.marginLeft = "-24px";
    }
    else {
        avatarNameStyle.top = showDate ? "30px" : 0;
        avatarNameStyle.left = "calc(" + avatarSize + " + 14px)";
        avatarNameStyle.width = "auto";
    }
    var sendUserFeedback = function (messageInfo, rating) {
        var feedback = {
            id: messageInfo.id,
            scenario_id: messageInfo.scenario_id,
            conversation_id: messageInfo.conversation_id,
            messaging_user_id: messageInfo.messaging_user_id,
            scene_id: messageInfo.scene_id,
            scene_custom_id: messageInfo.scene_custom_id,
            scene_name: messageInfo.scene_name,
            rating: rating
        };
        store.sendFeedback(feedback);
    };
    var onClickSendFeedback = function (e, messageInfo, rating) {
        e.preventDefault();
        e.stopPropagation();
        sendUserFeedback(messageInfo, rating);
        setFeedbackResult(rating);
        setShowFeedbackModal(false);
    };
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (displayMessages.length === 0) {
        return (React__default['default'].createElement("div", { ref: forwardedRef, style: __assign({}, style) },
            React__default['default'].createElement("div", { style: {
                    paddingRight: showAvatar && !isCustomWithoutBubble && !isOwn
                        ? isIE11
                            ? "0px"
                            : "40px"
                        : isOwn
                            ? "0px"
                            : "0px",
                    marginBottom: isLast && showFeedbackCollector ? "20px" : "0px"
                }, className: classnames__default['default']("bubble-group") },
                React__default['default'].createElement("li", { className: classnames__default['default']("bubble-list"), style: {
                        marginTop: !isOwn && displayAvatarName && displayAvatarName.length > 0 && !isCustomWithoutBubble ? "20px" : "0px"
                    } },
                    React__default['default'].createElement(BubbleLoader, { color: colors && colors.bubbleTextColor })))));
    }
    var lastMessage = hasInputMessage
        ? filteredMessage[filteredMessage.length - 2]
        : filteredMessage[filteredMessage.length - 1];
    var feedbackMaxWidth = "370px";
    if (lastMessage && (lastMessage.data_type === "carousel" || lastMessage.data_type === "text")) {
        feedbackMaxWidth = "260px";
    }
    else if (lastMessage && !mediaWithoutBubble && lastMessage.data_type === "media") {
        feedbackMaxWidth = "300px";
    }
    var avatar = avatarUrl;
    if (messageInfo.scene_emotion && emotionAvatar) {
        var emotion = emotionAvatar[messageInfo.scene_emotion];
        if (emotion) {
            avatar = emotion;
        }
    }
    if (isConsultant && messageInfo.sender && messageInfo.sender.avatar_url) {
        avatar = messageInfo.sender.avatar_url;
    }
    var marginTop = index === 0 ? (isCustomWithoutBubble ? "0px" : "10px") : "0px";
    return (React__default['default'].createElement("div", { ref: forwardedRef, style: __assign(__assign({}, style), { marginTop: marginTop }) },
        showFeedbackModal && (React__default['default'].createElement("div", { style: {
                position: "fixed",
                backgroundColor: "black",
                opacity: 0.8,
                width: "calc(100% + 20px)",
                height: scrollbar ? scrollbar.scrollHeight : 0,
                top: "-20px",
                left: "-20px",
                zIndex: 100
            }, onClick: function () {
                setShowFeedbackModal(false);
            } })),
        showDate && (React__default['default'].createElement("div", { className: "date-line" },
            React__default['default'].createElement("div", null, moment__default['default'].utc(messageInfo.created_at).local().format("YYYY-MM-DD (ddd)")))),
        React__default['default'].createElement("div", { style: {
                paddingRight: showAvatar && !isCustomWithoutBubble && !isOwn
                    ? isIE11
                        ? "0px"
                        : "40px"
                    : isOwn
                        ? "0px"
                        : "0px",
                marginBottom: isLast && showFeedbackCollector ? "20px" : "0px"
            }, className: classnames__default['default']("bubble-group", { odd: isOwn }) },
            showAvatar && !isCustomWithoutBubble && !isOwn && (React__default['default'].createElement("div", { style: {
                    marginBottom: hasQuickReply ? (isLast ? "100px" : "74px") : isLast ? "54px" : "28px",
                    marginRight: "2px",
                    alignSelf: avatarPosition === "bottom" ? "flex-end" : "flex-start",
                    display: "block",
                    zIndex: 10
                } },
                displayAvatarName && displayAvatarName.length > 0 && (React__default['default'].createElement("div", { style: avatarNameStyle }, displayAvatarName)),
                React__default['default'].createElement("img", { className: classnames__default['default']("avatar", { circle: roundAvatar }), src: avatar, alt: "", style: { width: avatarSize, height: avatarSize } }))),
            React__default['default'].createElement("li", { className: classnames__default['default']("bubble-list", { odd: isOwn }, { active: active && !focus, focus: focus }, { "has-without-bubble": hasWithoutBubble }), style: { marginTop: !isOwn && displayAvatarName && displayAvatarName.length > 0 && !isCustomWithoutBubble ? "20px" : "0px" } },
                displayMessages.map(function (message, index) {
                    var isLast = index === (hasInputMessage ? displayMessages.length - 2 : displayMessages.length - 1) ||
                        (displayMessages.length === 1 && displayMessages[0].type === "input");
                    if (!inputMessage ||
                        index < filteredMessage.length - 1 ||
                        (inputMessage && filteredMessage.length === 1)) {
                        return (React__default['default'].createElement(ChatBubble, { colors: colors, messageInfo: messageInfo, key: "bubble_" + index, message: message, isOwn: isOwn, disableInteraction: disableInteraction, active: active, focus: focus, index: index, isLast: isLast, isBotMessage: isBotMessage, avatarPosition: avatarPosition, showAvatar: showAvatar && !isCustomWithoutBubble, createdAt: messageInfo.created_at, inputMessage: (isLast && displayMessages.length === filteredMessage.length && inputMessage) ||
                                undefined, mediaWithoutBubble: mediaWithoutBubble, buttonTextAlign: buttonTextAlign, carouselButtonTextAlign: carouselButtonTextAlign, carouselButtonBorderRadius: carouselButtonBorderRadius, useReadMore: useReadMore, readMoreLine: readMoreLine, style: { zIndex: showFeedbackModal ? 2000 : 0 }, onLoad: function () {
                                if (shouldScrollToBottomRef.current) {
                                    scrollToBottom && scrollToBottom();
                                    setTimeout(function () {
                                        var scrollTop = scrollbar.scrollTop;
                                        var clientHeight = scrollbar.clientHeight;
                                        var scrollHeight = scrollbar.scrollHeight;
                                        var isScrollBottom = scrollTop + clientHeight > scrollHeight - 50;
                                        if (isScrollBottom) {
                                            shouldScrollToBottomRef.current = false;
                                        }
                                    }, 200);
                                }
                            }, windowWidth: windowWidth }));
                    }
                    return React__default['default'].createElement("div", { key: "bubble_" + index });
                }),
                intervalRef.current && React__default['default'].createElement(BubbleLoader, { color: colors && colors.bubbleTextColor }),
                isBotMessage && (React__default['default'].createElement("div", { style: {
                        display: "flex",
                        maxWidth: feedbackMaxWidth,
                        marginTop: "8px",
                        marginBottom: isLast ? "26px" : "0px",
                        height: "12px"
                    } },
                    showFeedbackModal && (React__default['default'].createElement("div", { className: "feedback-modal-button" },
                        React__default['default'].createElement(FeedbackGoodButton, { color: (colors && colors.feedbackGoodButtonColor) || "#707070", activeColor: (colors && colors.feedbackGoodButtonHoverColor) || "#000975", onClick: function (event) { return onClickSendFeedback(event, messageInfo, "good"); } }),
                        React__default['default'].createElement(FeedbackBadButton, { color: (colors && colors.feedbackBadButtonColor) || "#707070", activeColor: (colors && colors.feedbackBadButtonHoverColor) || "#000975", onClick: function (event) { return onClickSendFeedback(event, messageInfo, "bad"); } }))),
                    React__default['default'].createElement("div", { className: "chat-time bottom" }, moment__default['default'].utc(messageInfo.created_at).local().format("LT")),
                    showFeedbackCollector && (React__default['default'].createElement("div", { className: "feedback-button" },
                        React__default['default'].createElement("div", null, feedbackMessage),
                        React__default['default'].createElement(FeedbackGood, { fill: feedbackResult === "good", color: feedbackResult === "good"
                                ? (colors && colors.feedbackGoodButtonHoverColor) || "#000975"
                                : (colors && colors.feedbackGoodButtonColor) || "#707070", style: { width: "18px", marginLeft: "6px", marginRight: "1px" }, onClick: function (event) { return onClickSendFeedback(event, messageInfo, "good"); } }),
                        React__default['default'].createElement(FeedbackBad, { fill: feedbackResult === "bad", color: feedbackResult === "bad"
                                ? (colors && colors.feedbackBadButtonHoverColor) || "#000975"
                                : (colors && colors.feedbackBadButtonColor) || "#707070", style: { width: "18px" }, onClick: function (event) { return onClickSendFeedback(event, messageInfo, "bad"); } })))))))));
};

var ChatFeed = function (_a) {
    var showFooter = _a.showFooter, conversationId = _a.conversationId, messageInfos = _a.messageInfos, disableScrollToBottmOnUpdate = _a.disableScrollToBottmOnUpdate, shouldScrollToBottomOnInit = _a.shouldScrollToBottomOnInit, shouldScrollToMessageOnUpdate = _a.shouldScrollToMessageOnUpdate, disableInteraction = _a.disableInteraction, loadPrev = _a.loadPrev, loadNext = _a.loadNext, activeMessageIds = _a.activeMessageIds, focusMessageId = _a.focusMessageId, className = _a.className, style = _a.style, showAvatar = _a.showAvatar, avatarUrl = _a.avatarUrl, emotionAvatar = _a.emotionAvatar, avatarName = _a.avatarName, avatarSize = _a.avatarSize, roundAvatar = _a.roundAvatar, avatarPosition = _a.avatarPosition, clearCacheOnRender = _a.clearCacheOnRender, reverseOwner = _a.reverseOwner, mediaWithoutBubble = _a.mediaWithoutBubble, buttonTextAlign = _a.buttonTextAlign, carouselButtonTextAlign = _a.carouselButtonTextAlign, carouselButtonBorderRadius = _a.carouselButtonBorderRadius, hideCustomUIMessage = _a.hideCustomUIMessage, useReadMore = _a.useReadMore, readMoreLine = _a.readMoreLine, lockScroll = _a.lockScroll, messageDelay = _a.messageDelay, feedbackMessage = _a.feedbackMessage, showFeedbackCollector = _a.showFeedbackCollector, colors = _a.colors, windowWidth = _a.windowWidth, preventWelcomeScroll = _a.preventWelcomeScroll;
    var cellMeasurerCache = React.useRef(new reactVirtualized.CellMeasurerCache({ defaultHeight: 62, fixedWidth: true }));
    var scrollTimer = React.useRef(null);
    var isScrolling = React.useRef(false);
    var scrollBarRef = React.useRef(null);
    var virtualListRef = React.useRef(null);
    var messageInfosLengthRef = React.useRef(0);
    var messageInfoFirstItemIdRef = React.useRef();
    var shouldScrollToBottom = React.useRef(false);
    var shouldScrollToMessageId = React.useRef();
    var restoreScrollTop = React.useRef(-1);
    var shouldRestoreScroll = React.useRef(false);
    var isWelcomeRef = React.useRef(false);
    if (clearCacheOnRender) {
        cellMeasurerCache.current.clearAll();
    }
    var scrollToBottomWithDelay = function (time) {
        cancelScrollEvent();
        scrollTimer.current = setTimeout(scrollToBottom, time);
    };
    var scrollToItemWithDelay = function (time) {
        cancelScrollEvent();
        scrollTimer.current = setTimeout(scrollToItemId, time);
    };
    var scrollToYWithDelay = function (y, time) {
        cancelScrollEvent();
        scrollTimer.current = setTimeout(function () {
            scrollBarRef.current.scrollTop = y;
            if (!lockScroll) {
                shouldRestoreScroll.current = false;
            }
        }, time);
    };
    React.useEffect(function () {
        if (lockScroll) {
            shouldRestoreScroll.current = true;
            if (scrollBarRef.current) {
                restoreScrollTop.current = scrollBarRef.current.scrollTop;
            }
        }
        else {
            if (shouldRestoreScroll.current) {
                scrollToYWithDelay(restoreScrollTop.current, 100);
            }
        }
    }, [lockScroll]);
    React.useEffect(function () {
        if (!clearCacheOnRender) {
            cellMeasurerCache.current.clearAll();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conversationId]);
    React.useEffect(function () {
        // focusMessageId && scrollToItemWithDelay(focusMessageId, 100);
        shouldScrollToMessageId.current = focusMessageId;
        shouldScrollToMessageId.current && scrollToItemWithDelay(100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusMessageId]);
    React.useEffect(function () {
        if (shouldScrollToBottomOnInit && messageInfosLengthRef.current === 0) {
            shouldScrollToBottom.current = true;
        }
        if (shouldScrollToMessageOnUpdate &&
            messageInfosLengthRef.current > 0 &&
            messageInfosLengthRef.current < messageInfos.length) {
            if (messageInfoFirstItemIdRef.current) {
                var index = messageInfos.findIndex(function (message) { return message.id === messageInfoFirstItemIdRef.current; });
                if (index === 0) {
                    var startOfNewMessage = messageInfos[messageInfosLengthRef.current - 1];
                    shouldScrollToMessageId.current = startOfNewMessage.id;
                }
                else {
                    var startOfNewMessage = messageInfos[messageInfos.length - messageInfosLengthRef.current - 1];
                    shouldScrollToMessageId.current = startOfNewMessage.id;
                }
            }
            if (focusMessageId) {
                shouldScrollToMessageId.current = focusMessageId;
            }
        }
        if (!disableScrollToBottmOnUpdate && messageInfosLengthRef.current < messageInfos.length) {
            shouldScrollToBottom.current = true;
        }
        messageInfosLengthRef.current = messageInfos.length;
        isWelcomeRef.current = messageInfos.length < 2;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (shouldScrollToMessageOnUpdate) {
            shouldScrollToMessageId.current && scrollToItemWithDelay(100);
        }
        if (messageInfos[0]) {
            messageInfoFirstItemIdRef.current = messageInfos[0].id;
        }
    }, [messageInfos]);
    var cancelScrollEvent = function () {
        if (scrollTimer.current) {
            clearTimeout(scrollTimer.current);
        }
    };
    var scrollToBottom = function () {
        if (preventWelcomeScroll && messageInfos.length === 1) {
            // prevent scroll to bottom on welcome message
            return;
        }
        if (virtualListRef.current) {
            virtualListRef.current.scrollToRow(messageInfos.length - 1);
        }
        if (scrollBarRef.current) {
            scrollBarRef.current.scrollToBottom();
        }
    };
    var scrollToItemId = function () {
        if (!shouldScrollToMessageId.current) {
            return;
        }
        var index = messageInfos.findIndex(function (message) { return message.id === shouldScrollToMessageId.current; });
        if (index >= 0) {
            if (virtualListRef.current) {
                virtualListRef.current.scrollToRow(index);
                var focusOffsetTop = Math.round(virtualListRef.current.getOffsetForRow({ index: index, alignment: "auto" }));
                if (focusOffsetTop && scrollBarRef.current && scrollBarRef.current.scrollHeight > focusOffsetTop) {
                    scrollBarRef.current.scrollTop = focusOffsetTop;
                }
            }
            shouldScrollToMessageId.current = undefined;
        }
    };
    var loadMorePrev = React.useCallback(lodash.debounce(loadPrev || (function () { }), 500), []);
    var loadMoreNext = React.useCallback(lodash.debounce(loadNext || (function () { }), 500), []);
    var handleOnRowRendered = function (info) { };
    var handleScroll = function (params) {
        var scrollTop = params.scrollTop, clientHeight = params.clientHeight, scrollHeight = params.scrollHeight;
        var isTop = scrollTop < 50;
        var isBottom = scrollTop + clientHeight > scrollHeight - 50;
        if (isBottom) {
            loadMoreNext();
        }
        else if (isTop) {
            loadMorePrev();
        }
    };
    var rowRenderer = function (listRowProps) {
        var key = listRowProps.key, parent = listRowProps.parent, index = listRowProps.index, style = listRowProps.style;
        var messageInfo = messageInfos[index];
        var isLastItem = index === messageInfos.length - 1;
        if (shouldScrollToMessageId.current && messageInfo.id === shouldScrollToMessageId.current) {
            scrollToItemWithDelay(100);
        }
        if (isLastItem && shouldScrollToBottom.current) {
            scrollToBottomWithDelay(100);
        }
        return (React__default['default'].createElement(reactVirtualized.CellMeasurer, { key: key, parent: parent, cache: cellMeasurerCache.current, rowIndex: index, columnIndex: 0 }, function (_a) {
            var measure = _a.measure;
            return (React__default['default'].createElement(Measure__default['default'], { bounds: true, onResize: function (contentRect) {
                    var height = contentRect.bounds.height;
                    var width = contentRect.bounds.width;
                    var prevHeight = cellMeasurerCache.current.getHeight(index, 0);
                    if (prevHeight !== height) {
                        cellMeasurerCache.current.set(index, 0, width, height);
                        virtualListRef.current.recomputeGridSize({
                            rowIndex: index,
                            columnIndex: 0
                        });
                    }
                    measure();
                } }, function (_a) {
                var measureRef = _a.measureRef;
                var showDate = (index === 0 &&
                    Math.abs(moment__default['default'](new Date()).diff(moment__default['default'].utc(messageInfos[index].created_at).local(), "days")) > 0) ||
                    (index > 0 &&
                        Math.abs(moment__default['default']
                            .utc(messageInfos[index - 1].created_at)
                            .local()
                            .diff(moment__default['default'].utc(messageInfos[index].created_at).local(), "days")) > 0);
                return (React__default['default'].createElement(ChatBubbleGroup, { colors: colors, showDate: showDate, isWelcome: isWelcomeRef.current, messageDelay: messageDelay, reverseOwner: reverseOwner, avatarPosition: avatarPosition, showAvatar: showAvatar, avatarUrl: avatarUrl, emotionAvatar: emotionAvatar, avatarName: avatarName, avatarSize: avatarSize, roundAvatar: roundAvatar, hideCustomUIMessage: hideCustomUIMessage, key: "bubble_group_" + messageInfo.id, style: __assign(__assign({}, style), { height: "auto" }), forwardedRef: measureRef, messageInfo: messageInfo, disableInteraction: disableInteraction, mediaWithoutBubble: mediaWithoutBubble, buttonTextAlign: buttonTextAlign, carouselButtonTextAlign: carouselButtonTextAlign, carouselButtonBorderRadius: carouselButtonBorderRadius, useReadMore: useReadMore, readMoreLine: readMoreLine, feedbackMessage: feedbackMessage, showFeedbackCollector: showFeedbackCollector, scrollbar: scrollBarRef.current, scrollToBottom: function () {
                        if (!disableScrollToBottmOnUpdate) {
                            scrollToBottomWithDelay(200);
                        }
                    }, active: (activeMessageIds &&
                        messageInfo.id &&
                        activeMessageIds.indexOf(messageInfo.id) >= 0) ||
                        false, focus: focusMessageId === messageInfo.id, isLast: isLastItem, windowWidth: windowWidth, index: index }));
            }));
        }));
    };
    var overscanIndicesGetter = function (params) {
        if (params.direction === "horizontal") {
            return { overscanStartIndex: 0, overscanStopIndex: 0 };
        }
        var cellCount = params.cellCount, overscanCellsCount = params.overscanCellsCount, scrollDirection = params.scrollDirection, startIndex = params.startIndex, stopIndex = params.stopIndex;
        var isFirstItem = stopIndex === 0 && scrollDirection === -1;
        var isLastItem = cellCount - stopIndex === 1 && scrollDirection === 1;
        if (isLastItem) {
            if (focusMessageId && activeMessageIds && activeMessageIds.indexOf(focusMessageId) < 0) {
                loadMoreNext();
            }
        }
        else if (isFirstItem) {
            loadMorePrev();
        }
        return {
            overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
            overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
        };
    };
    return (React__default['default'].createElement("ul", { className: classnames__default['default']("chat-list", className, { "show-footer": showFooter }), style: style }, React__default['default'].createElement(reactVirtualized.AutoSizer, null, function (_a) {
        var width = _a.width, height = _a.height;
        return (React__default['default'].createElement(Scrollbar__default['default'], { scrollbarWidth: 6, noScrollX: true, ref: scrollBarRef, style: { width: width, height: height }, onUpdate: function (scrollValues, prevValues) {
                if (prevValues.scrollTop === scrollValues.scrollTop &&
                    prevValues.contentScrollHeight < scrollValues.contentScrollHeight &&
                    !disableScrollToBottmOnUpdate &&
                    shouldScrollToBottom.current) {
                    scrollToBottomWithDelay(100);
                }
                if (shouldScrollToMessageOnUpdate) {
                    shouldScrollToMessageId.current && scrollToItemWithDelay(100);
                }
            }, onScrollStart: function () {
                isScrolling.current = true;
                shouldScrollToBottom.current = false;
            }, onScrollStop: function () {
                isScrolling.current = false;
            }, onScroll: function (event) {
                if (virtualListRef.current) {
                    var scrollTop = event.scrollTop, scrollLeft = event.scrollLeft;
                    var grid = virtualListRef.current.Grid;
                    grid.handleScrollEvent({ scrollTop: scrollTop, scrollLeft: scrollLeft });
                    handleScroll(event);
                }
            } },
            React__default['default'].createElement(reactVirtualized.List, { width: width, height: height, style: { overflowX: false, overflowY: false, outline: "none" }, estimatedRowSize: 100, onRowsRendered: handleOnRowRendered, rowCount: messageInfos.length, overscanRowCount: 20, overscanIndicesGetter: overscanIndicesGetter, deferredMeasurementCache: cellMeasurerCache.current, 
                // onScroll={handleScroll}
                rowHeight: cellMeasurerCache.current.rowHeight, rowRenderer: rowRenderer, ref: virtualListRef })));
    })));
};

function keys(obj) {
    return Object.keys(obj);
}

var dummyDataEn = [
	{
		id: "c611160a-df92-4a7c-aac1-4b15ecd59a5f",
		scene_id: 1,
		scenario_id: "rZr",
		conversation_id: "57256ce4-6bb1-4ec4-9329-1df4e991e1c4",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		scene_custom_id: "1",
		messages: [
			{
				type: "output",
				data_type: "text",
				data: [
					{
						text: "Text Message"
					}
				]
			},
			{
				type: "input",
				data_type: "list",
				data: [
					{
						label: "Button 1",
						button_type: "next",
						next: "2",
						payload: "custom_id:2"
					},
					{
						label: "Button 2",
						button_type: "text"
					}
				]
			}
		],
		sender: {
			type: "bot",
			name: "chatbot"
		},
		created_at: "2019-08-21 01:09:15.242901",
		updated_at: "2019-08-21 01:09:15.242901",
		deleted_at: null
	},
	{
		id: "800b3acb-2c1f-408d-91f3-ff8eb963590b",
		scenario_id: "rZr",
		conversation_id: "0ae02c39-10d9-4751-9890-0d90ad6edb0d",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		sender: {
			type: "user"
		},
		messages: [
			{
				type: "output",
				data_type: "text",
				data: [
					{
						text: "User Message"
					}
				]
			}
		],
		created_at: "2019-08-21 00:55:09.49600",
		updated_at: "2019-08-21 00:55:09.49600"
	},
	{
		id: "6a95e8cb-5954-4e30-ab65-a7fcabcbd200",
		scene_id: 2,
		scenario_id: "rZr",
		conversation_id: "e2cc2120-9420-4cbc-b0bf-fda2aeb3def6",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		scene_custom_id: "2",
		messages: [
			{
				type: "output",
				data_type: "carousel",
				data: [
					{
						title: "Card Title",
						text: "Card Description...",
						buttons: [
							{
								label: "Card Button"
							}
						]
					},
					{
						buttons: [
							{
								label: "Card Button Not Ready",
								button_type: "link",
								link_mobile: "Preparing"
							}
						],
						title: "Card Title",
						text: "Card Description..."
					}
				]
			},
			{
				type: "input",
				data_type: "quick_reply",
				data: [
					{
						label: "Chip 1",
						button_type: "text"
					},
					{
						label: "Chip 2 Not Ready",
						button_type: "link",
						link_mobile: "Preparing"
					}
				]
			}
		],
		sender: {
			type: "bot",
			name: "chatbot"
		},
		created_at: "2019-08-21 01:19:32.462275",
		updated_at: "2019-08-21 01:19:32.462275",
		deleted_at: null
	},
	{
		id: "c611160a-df92-4a7c-aac1-4b15ecd59a5f",
		scene_id: 1,
		scenario_id: "rZr",
		conversation_id: "57256ce4-6bb1-4ec4-9329-1df4e991e1c4",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		scene_custom_id: "1",
		messages: [
			{
				type: "output",
				data_type: "text",
				data: [
					{
						text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi laoreet cursus nibh. In hac habitasse platea dictumst.\nPhasellus condimentum eros non orci condimentum, id aliquam enim consectetur. Donec consectetur lorem lorem, sed posuere ligula lobortis in.\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.\nCurabitur quis ante euismod, luctus enim at, feugiat mauris. Nam at arcu commodo, dignissim turpis nec, malesuada dolor. Praesent laoreet iaculis lobortis. Donec sed pulvinar elit, vitae aliquet elit. Nunc iaculis enim sem, eu consequat neque aliquam a. Proin consequat fermentum mauris tristique cursus. Nunc vitae consectetur mi. Aenean vel felis scelerisque diam volutpat pharetra eget in massa. Suspendisse molestie dolor a ante facilisis facilisis. Duis odio nunc, tincidunt vel rutrum at, pulvinar eget lorem. Nulla sit amet nibh augue."
					}
				]
			},
			{
				type: "input",
				data_type: "text"
			}
		],
		sender: {
			type: "bot",
			name: "chatbot"
		},
		created_at: "2019-08-21 01:09:15.242901",
		updated_at: "2019-08-21 01:09:15.242901",
		deleted_at: null
	}
];

var dummyDataKo = [
	{
		id: "c611160a-df92-4a7c-aac1-4b15ecd59a5f",
		scene_id: 1,
		scenario_id: "rZr",
		conversation_id: "57256ce4-6bb1-4ec4-9329-1df4e991e1c4",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		scene_custom_id: "1",
		messages: [
			{
				type: "output",
				data_type: "text",
				data: [
					{
						text: "텍스트"
					}
				]
			},
			{
				type: "input",
				data_type: "list",
				data: [
					{
						label: "버튼 1",
						button_type: "next",
						next: "2",
						payload: "custom_id:2"
					},
					{
						label: "버튼 2",
						button_type: "text"
					}
				]
			}
		],
		sender: {
			type: "bot",
			name: "chatbot"
		},
		created_at: "2019-08-21 01:09:15.242901",
		updated_at: "2019-08-21 01:09:15.242901",
		deleted_at: null
	},
	{
		id: "800b3acb-2c1f-408d-91f3-ff8eb963590b",
		scenario_id: "rZr",
		conversation_id: "0ae02c39-10d9-4751-9890-0d90ad6edb0d",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		sender: {
			type: "user"
		},
		messages: [
			{
				type: "output",
				data_type: "text",
				data: [
					{
						text: "사용자 메시지"
					}
				]
			}
		],
		created_at: "2019-08-21 00:55:09.49600",
		updated_at: "2019-08-21 00:55:09.49600"
	},
	{
		id: "6a95e8cb-5954-4e30-ab65-a7fcabcbd200",
		scene_id: 2,
		scenario_id: "rZr",
		conversation_id: "e2cc2120-9420-4cbc-b0bf-fda2aeb3def6",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		scene_custom_id: "2",
		messages: [
			{
				type: "output",
				data_type: "carousel",
				data: [
					{
						title: "카드 제목",
						text: "카드 본문",
						buttons: [
							{
								label: "카드 버튼"
							}
						]
					},
					{
						buttons: [
							{
								label: "카드 링크 버튼",
								button_type: "link",
								link_mobile: "http://m.naver.com"
							},
							{
								label: "카드 버튼 준비중",
								button_type: "link",
								link_mobile: "준비중"
							}
						],
						title: "카드 제목",
						text: "카드 본문"
					}
				]
			},
			{
				type: "input",
				data_type: "quick_reply",
				data: [
					{
						label: "퀵 리플라이 버튼 1",
						button_type: "text"
					},
					{
						label: "퀵 리플라이 준비중",
						button_type: "link",
						link_mobile: "준비중"
					}
				]
			}
		],
		sender: {
			type: "bot",
			name: "chatbot"
		},
		created_at: "2019-08-21 01:19:32.462275",
		updated_at: "2019-08-21 01:19:32.462275",
		deleted_at: null
	},
	{
		id: "c611160a-df92-4a7c-aac1-4b15ecd59a5f",
		scene_id: 1,
		scenario_id: "rZr",
		conversation_id: "57256ce4-6bb1-4ec4-9329-1df4e991e1c4",
		messaging_user_id: "cadb493e-578a-486e-b5b8-872e3baf4a71",
		scene_custom_id: "1",
		messages: [
			{
				type: "output",
				data_type: "text",
				data: [
					{
						text: "동해물과 백두산이 마르고 닳도록 하느님이 보우하사 우리나라 만세\n\n남산 위에 저 소나무 철갑을 두른 듯 바람서리 불변함은 우리 기상일세\n\n가을 하늘 공활한데 높고 구름 없이 밝은 달은 우리 가슴 일편단심일세\n\n이 기상과 이맘으로 충성을 다하여 괴로우나 즐거우나 나라 사랑하세\n\n무궁화 삼천리 화려강산 대한사람 대한으로 길이 보전하세."
					}
				]
			},
			{
				type: "input",
				data_type: "text"
			}
		],
		sender: {
			type: "bot",
			name: "chatbot"
		},
		created_at: "2019-08-21 01:09:15.242901",
		updated_at: "2019-08-21 01:09:15.242901",
		deleted_at: null
	}
];

var HighlighText = function (_a) {
    var text = _a.text, style = _a.style, highlightText = _a.highlightText, highlightStyle = _a.highlightStyle;
    var dataArray = splitByText(text, highlightText
        .replace("[", "")
        .replace("]", "")
        .replace("(", "")
        .replace(")", "")
        .replace("+", "")
        .replace("^", "")
        .replace("$", "")
        .replace("*", "")
        .replace("?", "")
        .replace("\b", "")
        .replace("B", ""));
    return (React__default['default'].createElement("div", { style: style }, dataArray.map(function (el, index) {
        if (el.toUpperCase() === highlightText.toUpperCase()) {
            return (React__default['default'].createElement("span", { key: "url" + index, style: highlightStyle }, el));
        }
        else {
            return React__default['default'].createElement(React.Fragment, { key: "text" + index }, el);
        }
    })));
};

var ClearableInput = React__default['default'].forwardRef(function (_a, ref) {
    var className = _a.className, placeholder = _a.placeholder, onChange = _a.onChange, onClear = _a.onClear, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, style = _a.style;
    var _b = React.useState(""), value = _b[0], setValue = _b[1];
    var handleChange = function (event) {
        setValue(event.target.value);
        onChange && onChange(event);
    };
    var clear = function () {
        setValue("");
    };
    return (React__default['default'].createElement("div", { className: classnames__default['default'](className), style: __assign({ display: "flex", width: "100%" }, style) },
        React__default['default'].createElement("input", { type: "text", value: value, placeholder: placeholder, ref: function (innerRef) {
                if (innerRef) {
                    innerRef.clear = clear;
                }
                if (ref) {
                    ref.current = innerRef;
                }
            }, onChange: handleChange, onKeyUp: function (event) {
                onKeyUp && onKeyUp(event);
            }, onKeyDown: function (event) {
                onKeyDown && onKeyDown(event);
            }, style: { width: "100%" } }),
        value && value.length > 0 && (React__default['default'].createElement("button", { onClick: function (event) {
                event.preventDefault();
                setValue("");
                onClear && onClear(event);
            }, style: {
                marginLeft: "auto",
                textDecoration: "none",
                border: "none",
                backgroundColor: "transparent",
                margin: 0,
                padding: 0,
                outline: "none",
                display: "flex",
                justifyContent: "center",
                width: "32px",
                height: "32px",
                alignSelf: "center"
            } },
            React__default['default'].createElement("img", { src: ClearIcon__default['default'], width: "12px", alt: "", style: { alignSelf: "center" } })))));
});

var WebChat = mobxReact.observer(function (_a) {
    var connectionConfig = _a.connectionConfig, scenarioId = _a.scenarioId, previousConversationId = _a.previousConversationId, className = _a.className, theme = _a.theme, disableInteraction = _a.disableInteraction, style = _a.style, locale = _a.locale, params = _a.params, onClickLogoutButton = _a.onClickLogoutButton;
    var messageRef = React.useRef(null);
    var suggestionTimerRef = React.useRef();
    var _b = React.useState(-1), suggestionListCursor = _b[0], setSuggestionListCursor = _b[1];
    var _c = React.useState(true), showDescription = _c[0], setShowDescription = _c[1];
    var _d = React.useState(false), showDisconnected = _d[0], setSowDisconnected = _d[1];
    var _e = React.useState((theme && theme.bottomMenu && theme.bottomMenu.enable && theme.bottomMenu.open && true) || false), showBottomMenu = _e[0], setShowBottomMenu = _e[1];
    var disconnectTimerRef = React.useRef();
    var intl = IntlStore.getInstance((theme && theme.locale) || locale).intl;
    React.useEffect(function () {
        // if (connectionConfig.dummy) {
        //     return;
        // }
        // chatStore.setConnectionConfig(connectionConfig);
        // const userKey = getUserKey();
        // const channel = connectionConfig.test ? "test" : "web";
        // if (connectionConfig.method === "socket") {
        //     chatStore.connectSocket(userKey, scenarioId, channel, { transports: ["websocket"] });
        // } else {
        //     chatStore
        //         .welcomeRest(userKey, scenarioId, channel)
        //         .then(() => {})
        //         .catch((e) => {
        //             console.error(e);
        //         });
        // }
        return function () {
            store.clear();
        };
    }, [scenarioId]);
    React.useEffect(function () {
        window.addEventListener("beforeunload", handleBeforeunload);
        return function () { return window.removeEventListener("beforeunload", handleBeforeunload); };
    }, [scenarioId]);
    React.useEffect(function () {
        if (!store.connected) {
            if (disconnectTimerRef.current) {
                clearTimeout(disconnectTimerRef.current);
            }
            disconnectTimerRef.current = setTimeout(function () {
                setSowDisconnected(connectionConfig.method === "socket" && store.data.length > 0 && !store.connected);
            }, 10000);
        }
        else {
            if (disconnectTimerRef.current) {
                clearTimeout(disconnectTimerRef.current);
            }
            setSowDisconnected(false);
        }
    }, [store.connected]);
    var handleBeforeunload = function (event) {
        store.disconnect();
    };
    var data = mobx.isObservable(store.data) ? JSON.parse(JSON.stringify(store.data)) : store.data;
    var messagingUserId = store.messagingUserId, conversationId = store.conversationId;
    if (connectionConfig.dummy) {
        var dummyData = dummyDataKo;
        if (locale === "en") {
            dummyData = dummyDataEn;
        }
        data = JSON.parse(JSON.stringify(dummyData));
    }
    var chatTheme = __assign(__assign({}, DEFAULT_WEBCHAT_THEME), theme);
    chatTheme.colors = __assign(__assign({}, DEFAULT_WEBCHAT_COLORS), chatTheme.colors);
    var showFooter = chatTheme.showFooter;
    var colors = chatTheme.colors || {};
    if (!colors.chatTitleBackgroundColorStart) {
        colors.chatTitleBackgroundColorStart = colors.chatTitleBackgroundColor;
        colors.chatTitleBackgroundColorEnd = colors.chatTitleBackgroundColor;
    }
    else if (!colors.chatTitleBackgroundColorEnd) {
        colors.chatTitleBackgroundColorEnd = colors.chatTitleBackgroundColorStart;
    }
    var vars = {};
    keys(colors).forEach(function (key) {
        var _a;
        var value = colors[key];
        if (value) {
            var test_1 = (_a = {},
                _a[STYLE_PROPERTY_KEYS[key]] = value,
                _a);
            vars = __assign(__assign({}, vars), test_1);
        }
    });
    cssVars__default['default']({
        rootElement: document,
        variables: vars
    });
    var bottomMenuFirstList = [];
    var bottomMenuSecondList = [];
    if (chatTheme.bottomMenu && chatTheme.bottomMenu.enable && chatTheme.bottomMenu.data) {
        if (chatTheme.bottomMenu.count === 3) {
            bottomMenuFirstList = chatTheme.bottomMenu.data;
        }
        else if (chatTheme.bottomMenu.count === 6) {
            bottomMenuFirstList = chatTheme.bottomMenu.data.slice(0, 3);
            bottomMenuSecondList = chatTheme.bottomMenu.data.slice(3, 6);
        }
        else if (chatTheme.bottomMenu.count === 8) {
            bottomMenuFirstList = chatTheme.bottomMenu.data.slice(0, 4);
            bottomMenuSecondList = chatTheme.bottomMenu.data.slice(4, 8);
        }
    }
    var onClickSendBtn = function (e) {
        e.preventDefault();
        if (!messageRef.current.value) {
            return;
        }
        try {
            var messages = makeUserMessages(messageRef.current.value);
            var chatData = makeUserData(scenarioId, conversationId, messagingUserId, messages);
            store.sendMessage(chatData);
        }
        catch (e) {
            console.error(e);
        }
        clearSuggestions();
    };
    var onKeyUpMessageInput = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.keyCode === 13) {
            if (!messageRef.current.value) {
                return;
            }
            if (disableInteraction) {
                return;
            }
            if (store.suggestions.length > 0 && suggestionListCursor >= 0) {
                try {
                    var messages = makeUserMessages(store.suggestions[suggestionListCursor]);
                    var chatData = makeUserData(scenarioId, conversationId, messagingUserId, messages);
                    store.sendMessage(chatData);
                }
                catch (e) {
                    console.error(e);
                }
                clearSuggestions();
                return;
            }
            try {
                var messages = makeUserMessages(messageRef.current.value);
                var chatData = makeUserData(scenarioId, conversationId, messagingUserId, messages);
                store.sendMessage(chatData);
            }
            catch (e) {
                console.error(e);
            }
            clearSuggestions();
        }
    };
    var onKeyDownMessageInput = function (e) {
        if (e.keyCode === 38 && store.suggestions.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            // Arrow Up
            var lastIndex = store.suggestions.slice(0, typeof theme.autoCompleteLimit === "string"
                ? parseInt(theme.autoCompleteLimit)
                : theme.autoCompleteLimit).length - 1;
            var cursor = suggestionListCursor - 1;
            if (cursor < 0) {
                cursor = lastIndex;
            }
            else if (cursor > lastIndex) {
                cursor = 0;
            }
            setSuggestionListCursor(cursor);
        }
        else if (e.keyCode === 40 && store.suggestions.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            // Arrow Down
            var lastIndex = store.suggestions.slice(0, typeof theme.autoCompleteLimit === "string"
                ? parseInt(theme.autoCompleteLimit)
                : theme.autoCompleteLimit).length - 1;
            var cursor = suggestionListCursor + 1;
            if (cursor < 0) {
                cursor = lastIndex;
            }
            else if (cursor > lastIndex) {
                cursor = 0;
            }
            setSuggestionListCursor(cursor);
        }
    };
    var onClickCloseBtn = function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.close();
    };
    var onClickLogoutBtn = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (onClickLogoutButton) {
            onClickLogoutButton();
        }
    };
    var onClickCloseDescriptionBtn = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setShowDescription(false);
    };
    var onClickToggleBottomMenu = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setShowBottomMenu(function (show) {
            return !show;
        });
    };
    var onClickConfirmBtn = function () {
        webChatDialogStore.confirm();
    };
    var getSuggestions = function (query) {
        if (suggestionTimerRef.current) {
            clearTimeout(suggestionTimerRef.current);
        }
        suggestionTimerRef.current = setTimeout(function () {
            store.getSuggestions(scenarioId, query).then(function () {
                setSuggestionListCursor(-1);
            });
        }, 200);
    };
    var clearSuggestions = function () {
        if (suggestionTimerRef.current) {
            clearTimeout(suggestionTimerRef.current);
        }
        if (messageRef.current) {
            messageRef.current.clear();
        }
        store.clearSuggestions();
        setSuggestionListCursor(-1);
    };
    var onClickSuggestion = function (e, value) {
        e.preventDefault();
        e.stopPropagation();
        try {
            var messages = makeUserMessages(value);
            var chatData = makeUserData(scenarioId, conversationId, messagingUserId, messages);
            store.sendMessage(chatData);
        }
        catch (e) {
            console.error(e);
        }
        clearSuggestions();
    };
    var onChangeInput = function (event) {
        var inputValue = event.target.value;
        theme && theme.useAutoComplete && getSuggestions(inputValue);
        if (inputValue.length === 0) {
            clearSuggestions();
        }
    };
    var onClickBottomMenuButton = function (e, button_data) {
        e.preventDefault();
        if (button_data.label) {
            if (button_data.button_type === "link" && button_data.link_mobile) {
                if (isUrl(button_data.link_mobile)) {
                    openLink(button_data.link_mobile, button_data.link_pc);
                }
                else {
                    webChatDialogStore.open({
                        title: intl.formatMessage({ id: "i0001" }),
                        message: button_data.link_mobile,
                        confirmText: intl.formatMessage({ id: "i0002" })
                    });
                }
            }
            else {
                try {
                    var messages = makeUserMessages(button_data.label, button_data.payload);
                    var chatData = makeUserData(store.scenarioId, store.conversationId, store.messagingUserId, messages);
                    store.sendMessage(chatData);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
        setShowBottomMenu(false);
    };
    return (React__default['default'].createElement(VisibilitySensor__default['default'], { onChange: function (isVisible) {
            if (isVisible) {
                if (connectionConfig.dummy) {
                    return;
                }
                store.setConnectionConfig(connectionConfig);
                var userKey = getUserKey();
                var channel = connectionConfig.test ? "test" : "web";
                if (connectionConfig.method === "socket") {
                    if (!store.connected) {
                        store.requestWelcome();
                        store.connectSocket(userKey, scenarioId, channel, previousConversationId, { transports: ["websocket"] }, params);
                    }
                }
                else {
                    store
                        .welcomeRest(userKey, scenarioId, channel)
                        .then(function () { })
                        .catch(function (e) {
                        console.error(e);
                    });
                }
            }
        } },
        React__default['default'].createElement("div", { id: "webchat-container", style: style, className: classnames__default['default']("chat-container", className) },
            React__default['default'].createElement("div", { className: "chat-title" },
                chatTheme.titleImageUrl && chatTheme.titleImageUrl.length > 0 ? (React__default['default'].createElement("img", { className: "chat-title-image", src: chatTheme.titleImageUrl, alt: "" })) : (React__default['default'].createElement("div", { className: "chat-title-text" }, chatTheme.title)),
                chatTheme.showLogoutButton && (React__default['default'].createElement("button", { className: classnames__default['default']("link-button"), style: { alignSelf: "center", position: "absolute", left: "20px" }, onClick: onClickLogoutBtn },
                    React__default['default'].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", className: "logout-button-svg" },
                        React__default['default'].createElement("path", { className: "st0", d: "M3 3h8V1H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v-2H3z" }),
                        React__default['default'].createElement("path", { className: "st0", d: "M19 10l-6-5v4H5v2h8v4l6-5z" })))),
                chatTheme.showCloseButton && (React__default['default'].createElement("button", { className: classnames__default['default']("link-button", "close-button"), style: { alignSelf: "center", position: "absolute", right: "20px" }, onClick: onClickCloseBtn },
                    React__default['default'].createElement("svg", { viewBox: "0 0 16 16", className: "close-button-svg" },
                        React__default['default'].createElement("path", { className: "st0", d: "M9,8l6.8-6.8c0.3-0.3,0.3-0.7,0-1c-0.3-0.3-0.7-0.3-1,0L8,7L1.2,0.2c-0.3-0.3-0.7-0.3-1,0c-0.3,0.3-0.3,0.7,0,1\n\tL7,8l-6.8,6.8c-0.3,0.3-0.3,0.7,0,1C0.3,15.9,0.5,16,0.7,16c0.2,0,0.4-0.1,0.5-0.2L8,9l6.8,6.8c0.1,0.1,0.3,0.2,0.5,0.2\n\ts0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-1L9,8z" }))))),
            showDescription && chatTheme.description && chatTheme.description.length > 0 && (React__default['default'].createElement("div", { className: "chat-description" },
                React__default['default'].createElement("div", { className: "chat-description-text" }, chatTheme.description),
                React__default['default'].createElement("button", { className: "link-button", style: { alignSelf: "center", marginLeft: "auto" }, onClick: onClickCloseDescriptionBtn },
                    React__default['default'].createElement("svg", { version: "1.1", id: "Capa_1", x: "0px", y: "0px", viewBox: "0 0 31.112 31.112", className: "close-button-svg" },
                        React__default['default'].createElement("polygon", { points: "31.112,1.414 29.698,0 15.556,14.142 1.414,0 0,1.414 14.142,15.556 0,29.698 1.414,31.112 15.556,16.97\n\t29.698,31.112 31.112,29.698 16.97,15.556 " }))))),
            showDisconnected && React__default['default'].createElement("div", { className: "chat-disconnected" }, intl.formatMessage({ id: "i0005" })),
            React__default['default'].createElement(ChatFeed, { showFooter: showFooter, colors: colors, avatarPosition: chatTheme.avatarPosition, showAvatar: chatTheme.showAvatar, mediaWithoutBubble: chatTheme.mediaWithoutBubble, buttonTextAlign: chatTheme.buttonTextAlign, carouselButtonTextAlign: chatTheme.carouselButtonTextAlign, carouselButtonBorderRadius: chatTheme.carouselButtonBorderRadius, avatarUrl: chatTheme.avatarUrl, emotionAvatar: chatTheme.emotionAvatar, avatarSize: chatTheme.avatarSize, avatarName: chatTheme.avatarName, roundAvatar: chatTheme.roundAvatar, conversationId: conversationId, messageInfos: data, disableInteraction: store.detectDuplicateConnection || disableInteraction, hideCustomUIMessage: chatTheme.hideCustomUIMessage, useReadMore: chatTheme.useReadMore, readMoreLine: chatTheme.readMoreLine, lockScroll: webChatDialogStore.show || lightBoxStore.show, messageDelay: chatTheme.messageDelay, feedbackMessage: chatTheme.feedbackText, showFeedbackCollector: chatTheme.useFeedbackCollector, windowWidth: (style && style.width) || 0, preventWelcomeScroll: chatTheme.preventWelcomeScroll }),
            theme &&
                theme.useAutoComplete &&
                store.suggestions.length > 0 &&
                messageRef.current &&
                messageRef.current.value &&
                messageRef.current.value.length > 0 && (React__default['default'].createElement("div", { className: "chat-suggestions-background" },
                React__default['default'].createElement("div", { className: classnames__default['default']("chat-suggestions", { "show-footer": showFooter }) }, store.suggestions
                    .slice(0, typeof theme.autoCompleteLimit === "string"
                    ? parseInt(theme.autoCompleteLimit)
                    : theme.autoCompleteLimit)
                    .map(function (suggestion, index) { return (React__default['default'].createElement("div", { key: "suggestion_" + index, className: classnames__default['default']("chat-suggestions-item", {
                        active: suggestionListCursor === index
                    }), onClick: function (event) {
                        return onClickSuggestion(event, suggestion);
                    } },
                    React__default['default'].createElement(HighlighText, { text: suggestion, highlightText: messageRef.current.value, highlightStyle: { color: colors.autocompleteHighlightColor }, style: {
                            alignSelf: "center"
                        } }))); })))),
            showBottomMenu && chatTheme.bottomMenu && chatTheme.bottomMenu.dim && (React__default['default'].createElement("div", { className: classnames__default['default']("chat-bottom-menu-background", {
                    enable: chatTheme.bottomMenu && chatTheme.bottomMenu.dim
                }) })),
            chatTheme.bottomMenu && chatTheme.bottomMenu.enable && (React__default['default'].createElement("div", { className: classnames__default['default']("chat-bottom-menu", {
                    show: showBottomMenu,
                    "show-footer": showFooter
                }) },
                bottomMenuFirstList.length > 0 && (React__default['default'].createElement("div", { style: {
                        display: "flex",
                        height: "100px",
                        justifyContent: "space-around",
                        borderTop: "solid 1px " + colors.bottomMenuBorderColor,
                        borderRight: "solid 1px " + colors.bottomMenuBorderColor
                    } }, bottomMenuFirstList.map(function (item, index) {
                    return (React__default['default'].createElement("div", { key: index, style: {
                            borderLeft: "solid 1px " + colors.bottomMenuBorderColor,
                            width: "100%",
                            height: "100%",
                            alignSelf: "center",
                            display: "flex",
                            position: "relative",
                            justifyContent: "center",
                            backgroundColor: colors.bottomMenuBackgroundColor
                        } },
                        React__default['default'].createElement("button", { className: "link-button", onClick: function (event) { return onClickBottomMenuButton(event, item); } },
                            item.image_type == "image" && (React__default['default'].createElement("img", { src: item.image_url, style: {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                } })),
                            item.image_type == "icon" && (React__default['default'].createElement("img", { src: item.image_url, style: { width: "24px", height: "24px" } })),
                            item.image_type === "icon" && (React__default['default'].createElement("div", { style: {
                                    marginTop: "4px",
                                    color: colors.bottomMenuTextColor
                                } }, item.label)))));
                }))),
                bottomMenuSecondList.length > 0 && (React__default['default'].createElement("div", { style: {
                        display: "flex",
                        height: "100px",
                        justifyContent: "space-around",
                        borderTop: "solid 1px " + colors.bottomMenuBorderColor,
                        borderRight: "solid 1px " + colors.bottomMenuBorderColor,
                        backgroundColor: colors.bottomMenuBackgroundColor
                    } }, bottomMenuSecondList.map(function (item, index) {
                    return (React__default['default'].createElement("div", { key: index, style: {
                            borderLeft: "solid 1px " + colors.bottomMenuBorderColor,
                            width: "100%",
                            height: "100%",
                            alignSelf: "center",
                            display: "flex",
                            position: "relative",
                            justifyContent: "center"
                        } },
                        React__default['default'].createElement("button", { className: "link-button", onClick: function (event) { return onClickBottomMenuButton(event, item); } },
                            item.image_type == "image" && (React__default['default'].createElement("img", { src: item.image_url, style: {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                } })),
                            item.image_type == "icon" && (React__default['default'].createElement("img", { src: item.image_url, style: { width: "24px", height: "24px" } })),
                            item.image_type === "icon" && (React__default['default'].createElement("div", { style: {
                                    marginTop: "4px",
                                    color: colors.bottomMenuTextColor
                                } }, item.label)))));
                }))))),
            React__default['default'].createElement("div", { className: "chat-input-container" },
                React__default['default'].createElement("div", { className: "chat-input" },
                    store.detectDuplicateConnection && (React__default['default'].createElement("div", { style: {
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.7)",
                            zIndex: 999999,
                            display: "flex",
                            justifyContent: "center",
                            left: 0
                        } },
                        React__default['default'].createElement("div", { style: {
                                color: "white",
                                fontSize: "16px",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                alignSelf: "center"
                            } }, intl.formatMessage({ id: "i0004" })))),
                    chatTheme.bottomMenu && chatTheme.bottomMenu.enable && (React__default['default'].createElement("div", { style: {
                            borderRight: "1px solid #e9e9e9",
                            width: "48px",
                            height: "48px",
                            flexShrink: 0
                        } },
                        React__default['default'].createElement("button", { className: "link-button", style: {
                                alignSelf: "center",
                                width: "48px",
                                height: "48px",
                                flexShrink: 0
                            }, onClick: onClickToggleBottomMenu },
                            showBottomMenu && (React__default['default'].createElement("svg", { x: "0px", y: "0px", viewBox: "0 0 200 200" },
                                React__default['default'].createElement("g", null,
                                    React__default['default'].createElement("g", null,
                                        React__default['default'].createElement("rect", { x: "57.86", y: "59.66", style: { fill: colors.bottomMenuButtonColor }, width: "35.52", height: "35.52" }),
                                        React__default['default'].createElement("rect", { x: "106.7", y: "59.66", style: { fill: colors.bottomMenuButtonColor }, width: "35.52", height: "35.52" })),
                                    React__default['default'].createElement("g", null,
                                        React__default['default'].createElement("rect", { x: "57.86", y: "104.06", style: { fill: colors.bottomMenuButtonColor }, width: "35.52", height: "35.52" }),
                                        React__default['default'].createElement("rect", { x: "106.7", y: "104.06", style: { fill: colors.bottomMenuButtonColor }, width: "35.52", height: "35.52" }))))),
                            !showBottomMenu && (React__default['default'].createElement("svg", { x: "0px", y: "0px", viewBox: "0 0 200 200" },
                                React__default['default'].createElement("rect", { x: "0.14", y: "-0.29", style: { fill: colors.bottomMenuButtonColor }, width: "199.81", height: "199.81" }),
                                React__default['default'].createElement("g", null,
                                    React__default['default'].createElement("g", null,
                                        React__default['default'].createElement("rect", { x: "57.86", y: "59.66", style: { fill: "#FFFFFF" }, width: "35.52", height: "35.52" }),
                                        React__default['default'].createElement("rect", { x: "106.7", y: "59.66", style: { fill: "#FFFFFF" }, width: "35.52", height: "35.52" })),
                                    React__default['default'].createElement("g", null,
                                        React__default['default'].createElement("rect", { x: "57.86", y: "104.06", style: { fill: "#FFFFFF" }, width: "35.52", height: "35.52" }),
                                        React__default['default'].createElement("rect", { x: "106.7", y: "104.06", style: { fill: "#FFFFFF" }, width: "35.52", height: "35.52" })))))))),
                    React__default['default'].createElement(ClearableInput, { style: { paddingLeft: "10px" }, ref: messageRef, onKeyUp: onKeyUpMessageInput, onKeyDown: onKeyDownMessageInput, onChange: onChangeInput, placeholder: chatTheme.chatInputPlaceholder, onClear: function () {
                            clearSuggestions();
                        } }),
                    React__default['default'].createElement("button", { disabled: disableInteraction, onClick: onClickSendBtn, className: "link-button" },
                        React__default['default'].createElement("div", { className: classnames__default['default']("send-button", {
                                disable: !(messageRef.current &&
                                    messageRef.current.value &&
                                    messageRef.current.value.length > 0)
                            }) },
                            React__default['default'].createElement("svg", { viewBox: "0 0 32 32", className: "send-button-image" },
                                React__default['default'].createElement("rect", { className: "cls-1", width: "32", height: "32", rx: "16" }),
                                React__default['default'].createElement("path", { className: "cls-2", d: "M22.79,8.87l-16.47,6a.27.27,0,0,0,0,.49l5.59,2.83a.24.24,0,0,0,.26,0l4.08-2.74a.26.26,0,0,1,.36.37l-2.73,4.07a.29.29,0,0,0,0,.27l2.84,5.59a.26.26,0,0,0,.48,0l6-16.47A.27.27,0,0,0,22.79,8.87Z" }))))),
                showFooter && (React__default['default'].createElement("div", { style: {
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#e9e9e9"
                    } },
                    React__default['default'].createElement("img", { style: { height: "30px", alignSelf: "center", cursor: "pointer" }, src: FooterLogo__default['default'], onMouseOver: function (e) { return (e.currentTarget.src = FooterLogoHover__default['default']); }, onMouseOut: function (e) { return (e.currentTarget.src = FooterLogo__default['default']); }, onClick: function (e) {
                            window.open("https://www.42maru.ai", "_blank");
                        } })))),
            React__default['default'].createElement(Modal__default['default'], { ariaHideApp: false, isOpen: webChatDialogStore.show, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, onRequestClose: function () {
                    webChatDialogStore.clear();
                }, style: {
                    overlay: {
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 9999999
                    },
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        padding: "0px",
                        borderRadius: "20px",
                        border: "solid 1px #c4c4c4",
                        transform: "translate(-50%, -50%)"
                    }
                }, parentSelector: function () {
                    return document.getElementById("webchat-container") || document.body;
                } },
                React__default['default'].createElement("div", { className: "popup" },
                    webChatDialogStore.title && (React__default['default'].createElement("div", { className: "popup-title" }, webChatDialogStore.title)),
                    React__default['default'].createElement("div", { className: "popup-message", style: {
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            overflow: "auto",
                            textAlign: webChatDialogStore.textAlign,
                            maxHeight: "40vh"
                        } },
                        React__default['default'].createElement(Linkify, null, webChatDialogStore.message)),
                    React__default['default'].createElement("div", { className: "popup-footer" },
                        React__default['default'].createElement("button", { className: "popup-button", onClick: onClickConfirmBtn }, webChatDialogStore.confirmText || intl.formatMessage({ id: "i0002" }))))),
            lightBoxStore.show && lightBoxStore.src && (React__default['default'].createElement(Lightbox__default['default'], { reactModalStyle: {
                    content: {
                        top: "45px"
                    }
                }, reactModalProps: {
                    ariaHideApp: false,
                    parentSelector: function () {
                        return document.getElementById("webchat-container") || document.body;
                    }
                }, mainSrc: lightBoxStore.src, onCloseRequest: function () { return lightBoxStore.clear(); } })))));
});

exports.ChatBubble = ChatBubble;
exports.ChatBubbleGroup = ChatBubbleGroup;
exports.ChatFeed = ChatFeed;
exports.ChatPlayer = ChatPlayer;
exports.DEFAULT_BOTTOM_MENU_SETTINGS = DEFAULT_BOTTOM_MENU_SETTINGS;
exports.DEFAULT_EMBEDD_SETTINGS = DEFAULT_EMBEDD_SETTINGS;
exports.DEFAULT_WEBCHAT_COLORS = DEFAULT_WEBCHAT_COLORS;
exports.DEFAULT_WEBCHAT_THEME = DEFAULT_WEBCHAT_THEME;
exports.STYLE_PROPERTY_KEYS = STYLE_PROPERTY_KEYS;
exports.WebChat = WebChat;
